// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./assets/css/animate.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,<svg viewBox=%270 0 16 16%27 fill=%27%234361ee%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,<svg viewBox=%270 0 16 16%27 fill=%27%23805dca%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,<svg viewBox=%270 0 16 16%27 fill=%27%2300ab55%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,<svg viewBox=%270 0 16 16%27 fill=%27%23e7515a%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,<svg viewBox=%270 0 16 16%27 fill=%27%23e2a03f%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,<svg viewBox=%270 0 16 16%27 fill=%27%232196f3%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,<svg viewBox=%270 0 16 16%27 fill=%27%233b3f5c%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animate css */

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.form-input,.form-textarea,.form-select,.form-multiselect{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}
.form-input:focus, .form-textarea:focus, .form-select:focus, .form-multiselect:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}
.form-input::-moz-placeholder, .form-textarea::-moz-placeholder{
  color: #6b7280;
  opacity: 1;
}
.form-input::placeholder,.form-textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}
.form-input::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}
.form-input::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}
.form-input::-webkit-datetime-edit{
  display: inline-flex;
}
.form-input::-webkit-datetime-edit,.form-input::-webkit-datetime-edit-year-field,.form-input::-webkit-datetime-edit-month-field,.form-input::-webkit-datetime-edit-day-field,.form-input::-webkit-datetime-edit-hour-field,.form-input::-webkit-datetime-edit-minute-field,.form-input::-webkit-datetime-edit-second-field,.form-input::-webkit-datetime-edit-millisecond-field,.form-input::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}
.form-select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-select:where([size]:not([size="1"])){
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
          print-color-adjust: unset;
}
.form-checkbox,.form-radio{
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}
.form-checkbox{
  border-radius: 0px;
}
.form-radio{
  border-radius: 100%;
}
.form-checkbox:focus,.form-radio:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}
.form-checkbox:checked,.form-radio:checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.form-checkbox:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@media (forced-colors: active) {

  .form-checkbox:checked{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}
.form-radio:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@media (forced-colors: active) {

  .form-radio:checked{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}
.form-checkbox:checked:hover,.form-checkbox:checked:focus,.form-radio:checked:hover,.form-radio:checked:focus{
  border-color: transparent;
  background-color: currentColor;
}
.form-checkbox:indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}
@media (forced-colors: active) {

  .form-checkbox:indeterminate{
    -webkit-appearance: auto;
       -moz-appearance: auto;
            appearance: auto;
  }
}
.form-checkbox:indeterminate:hover,.form-checkbox:indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}
html{
  scroll-behavior: smooth;
}
body{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
  font-family: Nunito, sans-serif;
}
body.dark{
  --tw-bg-opacity: 1;
  background-color: rgb(6 8 24 / var(--tw-bg-opacity, 1));
}
/* Panel */
.panel{
  position: relative;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.25rem;
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.panel:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(14 23 38 / var(--tw-bg-opacity, 1));
}
/* Navbar */
.navbar-sticky header,
    .navbar-floating header{
  position: sticky;
  top: 0px;
  z-index: 20;
}
.navbar-floating header{
  background-color: rgb(250 250 250 / 0.9);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
}
.navbar-floating header:is(.dark *){
  background-color: rgb(6 8 24 / 0.9);
}
.navbar-floating header > div .horizontal-menu{
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
/* Sidebar */
.sidebar:hover .nav-item > a{
  width: auto;
}
.sidebar .nav-item > button,
    .sidebar .nav-item > a{
  margin-bottom: 0.25rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
  border-radius: 0.375rem;
  padding: 0.625rem;
  --tw-text-opacity: 1;
  color: rgb(80 102 144 / var(--tw-text-opacity, 1));
}
.sidebar .nav-item > button:hover,
    .sidebar .nav-item > a:hover{
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.sidebar .nav-item > button:hover:is(.dark *),
    .sidebar .nav-item > a:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 31 50 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.sidebar .nav-item > button.active,
    .sidebar .nav-item > a.active{
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.sidebar .nav-item > button.active:is(.dark *),
    .sidebar .nav-item > a.active:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 31 50 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.sidebar .nav-item > button.active > div > span:is(.dark *),
    .sidebar .nav-item > a.active > div > span:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1)) !important;
}
.sidebar ul.sub-menu li button,
    .sidebar ul.sub-menu li a{
  display: flex;
  align-items: center;
  padding-left: 2.25rem;
  padding-right: 2.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.sidebar ul.sub-menu li button::before,
    .sidebar ul.sub-menu li a::before{
  height: 0.125rem;
  width: 0.5rem;
  border-radius: 0.25rem;
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.sidebar ul.sub-menu li button:hover,
    .sidebar ul.sub-menu li a:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.sidebar ul.sub-menu li button:hover::before,
    .sidebar ul.sub-menu li a:hover::before{
  content: var(--tw-content) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1)) !important;
}
.sidebar ul.sub-menu li button:is(.dark *)::before,
    .sidebar ul.sub-menu li a:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.sidebar ul.sub-menu li button:hover:is(.dark *),
    .sidebar ul.sub-menu li a:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.sidebar ul.sub-menu li button:where([dir="ltr"], [dir="ltr"] *)::before,
    .sidebar ul.sub-menu li a:where([dir="ltr"], [dir="ltr"] *)::before{
  content: var(--tw-content);
  margin-right: 0.5rem;
}
.sidebar ul.sub-menu li button:where([dir="rtl"], [dir="rtl"] *)::before,
    .sidebar ul.sub-menu li a:where([dir="rtl"], [dir="rtl"] *)::before{
  content: var(--tw-content);
  margin-left: 0.5rem;
}
.sidebar ul.sub-menu li button.active,
    .sidebar ul.sub-menu li a.active{
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.sidebar ul.sub-menu li button.active::before,
    .sidebar ul.sub-menu li a.active::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}
.sidebar .nav-item a div:first-child svg,
    .sidebar .nav-item button div:first-child svg{
  height: 1.25rem;
  width: 1.25rem;
  color: rgb(14 23 38 / 0.5);
}
.sidebar .nav-item a div:first-child svg:is(.dark *),
    .sidebar .nav-item button div:first-child svg:is(.dark *){
  color: rgb(255 255 255 / 0.5);
}
.main-container .main-content{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
@media (min-width: 1024px){

  .main-container .main-content:where([dir="ltr"], [dir="ltr"] *){
    margin-left: 260px;
  }

  .main-container .main-content:where([dir="rtl"], [dir="rtl"] *){
    margin-right: 260px;
  }
}
/* Horizontal layouts */
.horizontal .horizontal-menu{
  display: none;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 1024px){

  .horizontal .horizontal-menu{
    display: flex;
  }
}
.horizontal .horizontal-logo{
  display: flex;
}
.horizontal .main-container .main-content:where([dir="ltr"], [dir="ltr"] *){
  margin-left: 0px;
}
.horizontal .main-container .main-content:where([dir="rtl"], [dir="rtl"] *){
  margin-right: 0px;
}
.horizontal .sidebar:where([dir="ltr"], [dir="ltr"] *){
  left: -260px;
}
.horizontal .sidebar:where([dir="rtl"], [dir="rtl"] *){
  right: -260px;
}
.horizontal.toggle-sidebar .sidebar:where([dir="ltr"], [dir="ltr"] *){
  left: 0px;
}
@media (min-width: 1024px){

  .horizontal.toggle-sidebar .sidebar:where([dir="ltr"], [dir="ltr"] *){
    left: -260px;
  }
}
.horizontal.toggle-sidebar .sidebar:where([dir="rtl"], [dir="rtl"] *){
  right: 0px;
}
@media (min-width: 1024px){

  .horizontal.toggle-sidebar .sidebar:where([dir="rtl"], [dir="rtl"] *){
    right: -260px;
  }
}
.horizontal .nav-item a div:first-child svg,
    .horizontal .nav-item button div:first-child svg{
  height: 1.25rem;
  width: 1.25rem;
  color: rgb(14 23 38 / 0.5);
}
.horizontal .nav-item a div:first-child svg:is(.dark *),
    .horizontal .nav-item button div:first-child svg:is(.dark *){
  color: rgb(255 255 255 / 0.5);
}
.horizontal .dark .nav-item button div:first-child svg,
    .dark.horizontal .nav-item button div:first-child svg{
  color: rgb(255 255 255 / 0.5);
}
.horizontal-menu .nav-link{
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.horizontal-menu .nav-link:hover{
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.horizontal-menu .nav-link:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 31 50 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
@media (min-width: 1280px){

  .horizontal-menu .nav-link{
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.horizontal-menu .nav-link.active{
  background-color: rgb(0 0 0 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.horizontal-menu .nav-link.active:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(24 31 50 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.horizontal-menu ul.sub-menu{
  position: absolute;
  top: 100%;
  z-index: 10;
  display: none;
  min-width: 180px;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(59 63 92 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.horizontal-menu ul.sub-menu:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(27 46 75 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.horizontal-menu ul.sub-menu a,
    .horizontal-menu ul.sub-menu button{
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.horizontal-menu ul.sub-menu a:hover,
    .horizontal-menu ul.sub-menu button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.horizontal-menu ul.sub-menu a:hover:is(.dark *),
    .horizontal-menu ul.sub-menu button:hover:is(.dark *){
  background-color: rgb(67 97 238 / 0.1);
}
.horizontal-menu ul.sub-menu a.active,
    .horizontal-menu ul.sub-menu button.active{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.horizontal-menu ul.sub-menu a.active:is(.dark *),
    .horizontal-menu ul.sub-menu button.active:is(.dark *){
  background-color: rgb(67 97 238 / 0.1);
}
.horizontal-menu > li.nav-item:hover > ul.sub-menu,
    .horizontal-menu > li.nav-item > ul.sub-menu > li:hover > ul{
  display: block;
}
/* Vertical layouts */
.vertical.toggle-sidebar .horizontal-logo,
    .vertical.toggle-sidebar .collapse-icon{
  display: flex;
}
.vertical.toggle-sidebar .main-container .main-content:where([dir="ltr"], [dir="ltr"] *){
  margin-left: 0px;
}
.vertical.toggle-sidebar .main-container .main-content:where([dir="rtl"], [dir="rtl"] *){
  margin-right: 0px;
}
.vertical .sidebar:where([dir="ltr"], [dir="ltr"] *){
  left: -260px;
}
@media (min-width: 1024px){

  .vertical .sidebar:where([dir="ltr"], [dir="ltr"] *){
    left: 0px;
  }
}
.vertical .sidebar:where([dir="rtl"], [dir="rtl"] *){
  right: -260px;
}
@media (min-width: 1024px){

  .vertical .sidebar:where([dir="rtl"], [dir="rtl"] *){
    right: 0px;
  }
}
.vertical.toggle-sidebar .sidebar:where([dir="ltr"], [dir="ltr"] *){
  left: 0px;
}
@media (min-width: 1024px){

  .vertical.toggle-sidebar .sidebar:where([dir="ltr"], [dir="ltr"] *){
    left: -260px;
  }
}
.vertical.toggle-sidebar .sidebar:where([dir="rtl"], [dir="rtl"] *){
  right: 0px;
}
@media (min-width: 1024px){

  .vertical.toggle-sidebar .sidebar:where([dir="rtl"], [dir="rtl"] *){
    right: -260px;
  }
}
/* Collapsible vertical layouts */
.collapsible-vertical .sidebar:hover{
  width: 260px;
}
@media (min-width: 1024px){

  .collapsible-vertical .sidebar{
    width: 70px;
  }
}
.collapsible-vertical .sidebar:where([dir="ltr"], [dir="ltr"] *){
  left: -260px;
}
@media (min-width: 1024px){

  .collapsible-vertical .sidebar:where([dir="ltr"], [dir="ltr"] *){
    left: 0px;
  }
}
.collapsible-vertical .sidebar:where([dir="rtl"], [dir="rtl"] *){
  right: -260px;
}
@media (min-width: 1024px){

  .collapsible-vertical .sidebar:where([dir="rtl"], [dir="rtl"] *){
    right: 0px;
  }
}
.collapsible-vertical.toggle-sidebar .sidebar:where([dir="ltr"], [dir="ltr"] *){
  left: 0px;
}
.collapsible-vertical.toggle-sidebar .sidebar:where([dir="rtl"], [dir="rtl"] *){
  right: 0px;
}
@media (min-width: 1024px){

  .collapsible-vertical.toggle-sidebar .sidebar{
    width: 260px;
  }
}
.collapsible-vertical.toggle-sidebar .sidebar .nav-item > a{
  width: auto;
}
@media (min-width: 1024px){

  .collapsible-vertical.toggle-sidebar .main-content{
    width: calc(100% - 260px);
  }

  .collapsible-vertical.toggle-sidebar .main-content:where([dir="ltr"], [dir="ltr"] *){
    margin-left: 260px;
  }

  .collapsible-vertical.toggle-sidebar .main-content:where([dir="rtl"], [dir="rtl"] *){
    margin-right: 260px;
  }

  .collapsible-vertical .sidebar .sub-menu{
    display: none;
  }
}
.collapsible-vertical .sidebar:hover .sub-menu,
    .collapsible-vertical .sidebar:hover .sub-menu.recent-submenu,
    .collapsible-vertical.toggle-sidebar .sidebar .sub-menu{
  display: block;
}
@media (min-width: 1024px){

  .collapsible-vertical .main-content{
    width: calc(100% - 70px);
  }

  .collapsible-vertical .main-content:where([dir="ltr"], [dir="ltr"] *){
    margin-left: 70px;
  }

  .collapsible-vertical .main-content:where([dir="rtl"], [dir="rtl"] *){
    margin-right: 70px;
  }
}
.collapsible-vertical .sidebar .collapse-icon,
    .collapsible-vertical .main-logo > span{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
@media (min-width: 1024px){

  .collapsible-vertical .sidebar .collapse-icon,
    .collapsible-vertical .main-logo > span{
    opacity: 0;
  }
}
.collapsible-vertical .sidebar:hover .collapse-icon,
    .collapsible-vertical.toggle-sidebar .collapse-icon,
    .collapsible-vertical .sidebar:hover .main-logo > span,
    .collapsible-vertical.toggle-sidebar .main-logo > span{
  transition-duration: 500ms;
}
@media (min-width: 1024px){

  .collapsible-vertical .sidebar:hover .collapse-icon,
    .collapsible-vertical.toggle-sidebar .collapse-icon,
    .collapsible-vertical .sidebar:hover .main-logo > span,
    .collapsible-vertical.toggle-sidebar .main-logo > span{
    opacity: 1;
  }
}
.collapsible-vertical.toggle-sidebar .sidebar .collapse-icon{
  display: flex;
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.collapsible-vertical .sidebar:hover .collapse-icon{
  display: flex;
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.collapsible-vertical .sidebar ul > h2 span{
  display: none;
  white-space: nowrap;
}
.collapsible-vertical .sidebar ul > h2 svg{
  display: block;
}
.collapsible-vertical .sidebar:hover ul > h2 span,
    .collapsible-vertical.toggle-sidebar .sidebar ul > h2 span{
  display: inline;
}
.collapsible-vertical .sidebar:hover ul > h2 svg,
    .collapsible-vertical.toggle-sidebar .sidebar ul > h2 svg{
  display: none;
}
/* boxed-layout */
.boxed-layout{
  margin-left: auto;
  margin-right: auto;
  max-width: 1400px;
}
.boxed-layout.vertical .sidebar,
    .boxed-layout.collapsible-vertical .sidebar{
  overflow: hidden;
}
@media (min-width: 1024px){

  .boxed-layout.vertical .sidebar:where([dir="ltr"], [dir="ltr"] *),
    .boxed-layout.collapsible-vertical .sidebar:where([dir="ltr"], [dir="ltr"] *){
    left: auto;
  }

  .boxed-layout.vertical .sidebar:where([dir="rtl"], [dir="rtl"] *),
    .boxed-layout.collapsible-vertical .sidebar:where([dir="rtl"], [dir="rtl"] *){
    right: auto;
  }

  .boxed-layout.vertical.toggle-sidebar .sidebar{
    width: 0px;
  }
}
/* Buttons */
.btn{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-shadow: 0 10px 20px -10px;
  --tw-shadow-colored: 0 10px 20px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.btn:hover{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn[disabled]{
  cursor: not-allowed;
  opacity: 0.6;
}
.btn-primary{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(67 97 238 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-outline-primary{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-outline-primary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.btn-secondary{
  --tw-border-opacity: 1;
  border-color: rgb(128 93 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(128 93 202 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(128 93 202 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-success{
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(0 171 85 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-danger{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(231 81 90 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-outline-danger{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(231 81 90 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-outline-danger:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.btn-warning{
  --tw-border-opacity: 1;
  border-color: rgb(226 160 63 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(226 160 63 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(226 160 63 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-info{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(33 150 243 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.btn-dark{
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(59 63 92 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(59 63 92 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
/* Badge */
.badge{
  position: relative;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: transparent;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.badge-outline-primary{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.badge-outline-primary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 241 255 / var(--tw-bg-opacity, 1));
}
.badge-outline-primary:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
.badge-outline-secondary{
  --tw-border-opacity: 1;
  border-color: rgb(128 93 202 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(128 93 202 / var(--tw-text-opacity, 1));
}
.badge-outline-secondary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(235 228 247 / var(--tw-bg-opacity, 1));
}
.badge-outline-secondary:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(128 93 202 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
.badge-outline-success{
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(0 171 85 / var(--tw-text-opacity, 1));
}
.badge-outline-success:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(221 245 240 / var(--tw-bg-opacity, 1));
}
.badge-outline-success:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
.badge-outline-danger{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(231 81 90 / var(--tw-text-opacity, 1));
}
.badge-outline-danger:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 245 / var(--tw-bg-opacity, 1));
}
.badge-outline-danger:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
.badge-outline-warning{
  --tw-border-opacity: 1;
  border-color: rgb(226 160 63 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(226 160 63 / var(--tw-text-opacity, 1));
}
.badge-outline-warning:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 249 237 / var(--tw-bg-opacity, 1));
}
.badge-outline-warning:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(226 160 63 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
.badge-outline-info{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
}
.badge-outline-info:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(231 247 255 / var(--tw-bg-opacity, 1));
}
.badge-outline-info:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
.badge-outline-dark{
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(59 63 92 / var(--tw-text-opacity, 1));
}
.badge-outline-dark:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 234 236 / var(--tw-bg-opacity, 1));
}
.badge-outline-dark:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(59 63 92 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
/* Form */
.form-input,
    .form-textarea,
    .form-select,
    .form-multiselect{
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(224 230 237 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.form-input:focus,
    .form-textarea:focus,
    .form-select:focus,
    .form-multiselect:focus{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  --tw-ring-color: transparent;
}
.form-input:is(.dark *),
    .form-textarea:is(.dark *),
    .form-select:is(.dark *),
    .form-multiselect:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(23 38 60 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(18 30 50 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.form-input:focus:is(.dark *),
    .form-textarea:focus:is(.dark *),
    .form-select:focus:is(.dark *),
    .form-multiselect:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
}
label{
  margin-bottom: 0.375rem;
  display: block;
  font-weight: 600;
}
[dir='rtl'] select {
        background-position: left 0.5rem center;
    }
.has-error .form-input,
    .has-error .form-textarea,
    .has-error .form-select,
    .has-error .form-multiselect,
    .has-error .multiselect__tags{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  background-color: rgb(231 81 90 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(231 81 90 / var(--tw-text-opacity, 1));
}
.has-error .form-input::-moz-placeholder, .has-error .form-textarea::-moz-placeholder, .has-error .form-select::-moz-placeholder, .has-error .form-multiselect::-moz-placeholder, .has-error .multiselect__tags::-moz-placeholder{
  color: rgb(231 81 90 / 0.7);
}
.has-error .form-input::placeholder,
    .has-error .form-textarea::placeholder,
    .has-error .form-select::placeholder,
    .has-error .form-multiselect::placeholder,
    .has-error .multiselect__tags::placeholder{
  color: rgb(231 81 90 / 0.7);
}
.has-error .form-input:focus,
    .has-error .form-textarea:focus,
    .has-error .form-select:focus,
    .has-error .form-multiselect:focus,
    .has-error .multiselect__tags:focus{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
}
.has-error .multiselect__tags:hover,
    .has-error .form-checkbox{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
}
.has-success .form-input,
    .has-success .form-textarea,
    .has-success .form-select,
    .has-success .form-multiselect,
    .has-success .multiselect__tags{
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  background-color: rgb(0 171 85 / 0.08);
  --tw-text-opacity: 1;
  color: rgb(0 171 85 / var(--tw-text-opacity, 1));
}
.has-success .form-input::-moz-placeholder, .has-success .form-textarea::-moz-placeholder, .has-success .form-select::-moz-placeholder, .has-success .form-multiselect::-moz-placeholder, .has-success .multiselect__tags::-moz-placeholder{
  color: rgb(0 171 85 / 0.7);
}
.has-success .form-input::placeholder,
    .has-success .form-textarea::placeholder,
    .has-success .form-select::placeholder,
    .has-success .form-multiselect::placeholder,
    .has-success .multiselect__tags::placeholder{
  color: rgb(0 171 85 / 0.7);
}
.has-success .form-input:focus,
    .has-success .form-textarea:focus,
    .has-success .form-select:focus,
    .has-success .form-multiselect:focus,
    .has-success .multiselect__tags:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
}
/* checkbox & radio */
.form-radio,
    .form-checkbox{
  height: 1.25rem;
  width: 1.25rem;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(224 230 237 / var(--tw-border-opacity, 1));
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
  --tw-ring-offset-width: 0px !important;
}
.form-radio:checked,
    .form-checkbox:checked{
  background-size: 90% 90%;
}
.form-radio:disabled,
    .form-checkbox:disabled{
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity, 1));
}
.form-radio:is(.dark *),
    .form-checkbox:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(37 59 92 / var(--tw-border-opacity, 1));
}
.form-radio:checked:is(.dark *),
    .form-checkbox:checked:is(.dark *){
  border-color: transparent;
}
.form-radio:disabled:is(.dark *),
    .form-checkbox:disabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(27 46 75 / var(--tw-bg-opacity, 1));
}
.form-radio:where([dir="ltr"], [dir="ltr"] *),
    .form-checkbox:where([dir="ltr"], [dir="ltr"] *){
  margin-right: 0.375rem;
}
.form-radio:where([dir="rtl"], [dir="rtl"] *),
    .form-checkbox:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 0.375rem;
}
.form-checkbox.outline-primary:checked{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  background-color: transparent;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-checkbox.outline-secondary:checked{
  --tw-border-opacity: 1;
  border-color: rgb(128 93 202 / var(--tw-border-opacity, 1));
  background-color: transparent;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-checkbox.outline-success:checked{
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  background-color: transparent;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-checkbox.outline-danger:checked{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  background-color: transparent;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-checkbox.outline-warning:checked{
  --tw-border-opacity: 1;
  border-color: rgb(226 160 63 / var(--tw-border-opacity, 1));
  background-color: transparent;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.form-checkbox.outline-info:checked{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
  background-color: transparent;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.form-checkbox.outline-dark:checked{
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  background-color: transparent;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.form-radio{
  border-radius: 9999px;
}
.form-radio.outline-primary:checked{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
  background-color: transparent;
  background-image: none;
}
.form-radio.outline-secondary:checked{
  --tw-border-opacity: 1;
  border-color: rgb(128 93 202 / var(--tw-border-opacity, 1));
  background-color: transparent;
  background-image: none;
}
.form-radio.outline-success:checked{
  --tw-border-opacity: 1;
  border-color: rgb(0 171 85 / var(--tw-border-opacity, 1));
  background-color: transparent;
  background-image: none;
}
.form-radio.outline-danger:checked{
  --tw-border-opacity: 1;
  border-color: rgb(231 81 90 / var(--tw-border-opacity, 1));
  background-color: transparent;
  background-image: none;
}
.form-radio.outline-warning:checked{
  --tw-border-opacity: 1;
  border-color: rgb(226 160 63 / var(--tw-border-opacity, 1));
  background-color: transparent;
  background-image: none;
}
.form-radio.outline-info:checked{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
  background-color: transparent;
  background-image: none;
}
.form-radio.outline-dark:checked{
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  background-color: transparent;
  background-image: none;
}
/* dropdown */
.dropdown{
  position: relative;
}
.dropdown > button{
  display: flex;
}
.dropdown ul{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  min-width: 120px;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 0px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dropdown ul:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(27 46 75 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.dropdown ul li > a,
    .dropdown ul li > button{
  display: flex;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.dropdown ul li > a:hover,
    .dropdown ul li > button:hover{
  background-color: rgb(67 97 238 / 0.1);
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.dropdown ul li > button{
  width: 100%;
}
/* tables */
.table-responsive{
  overflow: auto;
}
table{
  width: 100%;
  border-collapse: collapse !important;
}
table thead tr,
    table tfoot tr{
  border-bottom-width: 0px;
  background-color: rgb(224 230 237 / 0.3);
}
table thead tr:is(.dark *),
    table tfoot tr:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(26 41 65 / var(--tw-bg-opacity, 1)) !important;
}
table thead tr th,
    table tfoot tr th,
    table tbody tr td{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
table thead tr th:where([dir="ltr"], [dir="ltr"] *),
    table tfoot tr th:where([dir="ltr"], [dir="ltr"] *),
    table tbody tr td:where([dir="ltr"], [dir="ltr"] *){
  text-align: left;
}
table thead tr th:where([dir="rtl"], [dir="rtl"] *),
    table tfoot tr th:where([dir="rtl"], [dir="rtl"] *),
    table tbody tr td:where([dir="rtl"], [dir="rtl"] *){
  text-align: right;
}
table thead tr th,
    table tfoot tr th{
  font-weight: 600;
}
table tbody tr{
  border-bottom-width: 1px;
  border-color: rgb(224 230 237 / 0.4) !important;
}
table tbody tr:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(25 30 58 / var(--tw-border-opacity, 1)) !important;
}
/* code hightlight */
pre {
        direction: ltr;
    }
.pointer-events-none{
  pointer-events: none;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-6{
  bottom: 1.5rem;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[51\\]{
  z-index: 51;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[999\\]{
  z-index: 999;
}
.m-0{
  margin: 0px;
}
.m-auto{
  margin: auto;
}
.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-\\[1px\\]{
  margin-bottom: -1px;
}
.-mt-12{
  margin-top: -3rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-11{
  margin-bottom: 2.75rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-\\[5px\\]{
  margin-left: 5px;
}
.mt-0{
  margin-top: 0px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.\\!block{
  display: block !important;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-20{
  height: 5rem;
}
.h-4{
  height: 1rem;
}
.h-4\\.5{
  height: 18px;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[290px\\]{
  height: 290px;
}
.h-\\[calc\\(100vh-80px\\)\\]{
  height: calc(100vh - 80px);
}
.h-full{
  height: 100%;
}
.max-h-80{
  max-height: 20rem;
}
.min-h-\\[190px\\]{
  min-height: 190px;
}
.min-h-\\[325px\\]{
  min-height: 325px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-11\\/12{
  width: 91.666667%;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-20{
  width: 5rem;
}
.w-3\\/4{
  width: 75%;
}
.w-4{
  width: 1rem;
}
.w-4\\.5{
  width: 18px;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[230px\\]{
  width: 230px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-full{
  width: 100%;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-full{
  min-width: 100%;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-none{
  flex: none;
}
.shrink-0{
  flex-shrink: 0;
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-\\[spin_3s_linear_infinite\\]{
  animation: spin 3s linear infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-content-center{
  place-content: center;
}
.items-start{
  align-items: flex-start;
}
.items-center{
  align-items: center;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-1{
  gap: 0.25rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-6{
  gap: 1.5rem;
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.space-y-9 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.25rem * var(--tw-space-y-reverse));
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-white-light{
  --tw-border-opacity: 1 !important;
  border-color: rgb(224 230 237 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#ebe9f1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(235 233 241 / var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(14 23 38 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-primary{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white-light{
  --tw-border-opacity: 1;
  border-color: rgb(224 230 237 / var(--tw-border-opacity, 1));
}
.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}
.\\!border-b-white{
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-l-transparent{
  border-left-color: transparent !important;
}
.bg-\\[\\#1b2e4b\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(27 46 75 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ebedf2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 237 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1f2f3\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(241 242 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafafa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fbfbfb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(251 251 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffeccb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 236 203 / var(--tw-bg-opacity, 1));
}
.bg-\\[black\\]\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(14 23 38 / var(--tw-bg-opacity, 1));
}
.bg-black\\/50{
  background-color: rgb(14 23 38 / 0.5);
}
.bg-black\\/60{
  background-color: rgb(14 23 38 / 0.6);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-danger{
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
}
.bg-danger-light{
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 245 / var(--tw-bg-opacity, 1));
}
.bg-dark-light{
  --tw-bg-opacity: 1;
  background-color: rgb(234 234 236 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-info{
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
}
.bg-info-light{
  --tw-bg-opacity: 1;
  background-color: rgb(231 247 255 / var(--tw-bg-opacity, 1));
}
.bg-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}
.bg-primary-light{
  --tw-bg-opacity: 1;
  background-color: rgb(234 241 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-secondary{
  --tw-bg-opacity: 1;
  background-color: rgb(128 93 202 / var(--tw-bg-opacity, 1));
}
.bg-secondary-light{
  --tw-bg-opacity: 1;
  background-color: rgb(235 228 247 / var(--tw-bg-opacity, 1));
}
.bg-success{
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
}
.bg-success-light{
  --tw-bg-opacity: 1;
  background-color: rgb(221 245 240 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-warning{
  --tw-bg-opacity: 1;
  background-color: rgb(226 160 63 / var(--tw-bg-opacity, 1));
}
.bg-warning-light{
  --tw-bg-opacity: 1;
  background-color: rgb(255 249 237 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white-light\\/30{
  background-color: rgb(224 230 237 / 0.3);
}
.bg-white-light\\/40{
  background-color: rgb(224 230 237 / 0.4);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#3cba92\\]{
  --tw-gradient-from: #3cba92 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(60 186 146 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#4361ee\\]{
  --tw-gradient-from: #4361ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 97 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#7579ff\\]{
  --tw-gradient-from: #7579ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(117 121 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#f09819\\]{
  --tw-gradient-from: #f09819 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 152 25 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#0ba360\\]{
  --tw-gradient-to: #0ba360 var(--tw-gradient-to-position);
}
.to-\\[\\#160f6b\\]{
  --tw-gradient-to: #160f6b var(--tw-gradient-to-position);
}
.to-\\[\\#b224ef\\]{
  --tw-gradient-to: #b224ef var(--tw-gradient-to-position);
}
.to-\\[\\#ff5858\\]{
  --tw-gradient-to: #ff5858 var(--tw-gradient-to-position);
}
.fill-\\[url\\(\\#linear-gradient\\)\\]{
  fill: url(#linear-gradient);
}
.fill-white{
  fill: #ffffff;
}
.object-cover{
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.\\!py-0{
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-nunito{
  font-family: Nunito, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.leading-none{
  line-height: 1;
}
.text-\\[\\#031A61\\]{
  --tw-text-opacity: 1;
  color: rgb(3 26 97 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f2937\\]{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2795D0\\]{
  --tw-text-opacity: 1;
  color: rgb(39 149 208 / var(--tw-text-opacity, 1));
}
.text-\\[\\#515365\\]{
  --tw-text-opacity: 1;
  color: rgb(81 83 101 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}
.text-black\\/60{
  color: rgb(14 23 38 / 0.6);
}
.text-black\\/70{
  color: rgb(14 23 38 / 0.7);
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-danger{
  --tw-text-opacity: 1;
  color: rgb(231 81 90 / var(--tw-text-opacity, 1));
}
.text-dark{
  --tw-text-opacity: 1;
  color: rgb(59 63 92 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-info{
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
}
.text-primary{
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-secondary{
  --tw-text-opacity: 1;
  color: rgb(128 93 202 / var(--tw-text-opacity, 1));
}
.text-success{
  --tw-text-opacity: 1;
  color: rgb(0 171 85 / var(--tw-text-opacity, 1));
}
.text-warning{
  --tw-text-opacity: 1;
  color: rgb(226 160 63 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white-dark{
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}
.text-white-light{
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[5px_0_25px_0_rgba\\(94\\2c 92\\2c 154\\2c 0\\.1\\)\\]{
  --tw-shadow: 5px 0 25px 0 rgba(94,92,154,0.1);
  --tw-shadow-colored: 5px 0 25px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#ebedf2\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(235 237 242 / var(--tw-ring-opacity, 1));
}
.ring-primary\\/30{
  --tw-ring-color: rgb(67 97 238 / 0.3);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.saturate-50{
  --tw-saturate: saturate(.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[display\\]{
  transition-property: display;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[right\\]{
  transition-property: right;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* perfect scrollbar */
.ps__rail-y > .ps__thumb-y,
.ps__rail-y > .ps__thumb-y{
  width: 0.375rem !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(221 221 221 / var(--tw-bg-opacity, 1)) !important;
}
.ps__rail-y > .ps__thumb-y:is(.dark *),
.ps__rail-y > .ps__thumb-y:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(45 51 76 / var(--tw-bg-opacity, 1)) !important;
}
.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking{
  opacity: 0.6 !important;
  background-color: transparent !important;
}

/* swal2 */
.swal2-container .swal2-close{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.swal2-container .swal2-close:hover{
  --tw-text-opacity: 1;
  color: rgb(234 234 236 / var(--tw-text-opacity, 1));
}
.swal2-container .swal2-close:focus{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.swal2-container .swal2-popup.swal2-toast{
  --tw-bg-opacity: 1;
  background-color: rgb(59 63 92 / var(--tw-bg-opacity, 1));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.swal2-popup.swal2-toast .swal2-title,
.swal2-container .swal2-popup.swal2-toast .swal2-html-container{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}

.swal2-container .swal2-popup.swal2-toast.color-secondary{
  --tw-bg-opacity: 1;
  background-color: rgb(128 93 202 / var(--tw-bg-opacity, 1));
}

.swal2-container .swal2-popup.swal2-toast.color-warning{
  --tw-bg-opacity: 1;
  background-color: rgb(226 160 63 / var(--tw-bg-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-info{
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-danger{
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
}
.swal2-container .swal2-popup.swal2-toast.color-success{
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
}

/* apex chart */
.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light,
.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light {
    box-shadow: none;
    border-color: #050717cc;
    background-color: #050717cc;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.apexcharts-canvas .apexcharts-xaxistooltip-bottom:before,
.apexcharts-canvas .apexcharts-xaxistooltip-bottom:after{
  border-bottom-color: #050717cc;
}

.apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title{
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(6 8 24 / var(--tw-bg-opacity, 1));
}

.apexcharts-legend-series:where([dir="ltr"], [dir="ltr"] *){
  margin-right: 0.5rem !important;
}

.apexcharts-legend-series:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 0.5rem !important;
}

.dark .apexcharts-title-text {
    fill: #e0e6ed;
}

.dark .apexcharts-canvas .apexcharts-text.apexcharts-xaxis-label,
.dark .apexcharts-canvas .apexcharts-text.apexcharts-yaxis-label {
    fill: #e0e6ed;
}

.dark .apexcharts-canvas .apexcharts-text,
.dark .apexcharts-canvas .apexcharts-text {
    fill: #e0e6ed;
}

.dark .apexcharts-canvas .apexcharts-legend-text {
    color: #e0e6ed !important;
}

.dark .apexcharts-canvas .apexcharts-radialbar-track.apexcharts-track .apexcharts-radialbar-area {
    stroke: #191e3a;
}
.dark .apexcharts-canvas .apexcharts-series-markers.apexcharts-series-bubble .apexcharts-marker {
    stroke: #191e3a;
}

.dark .apexcharts-canvas .apexcharts-pie-label,
.dark .apexcharts-canvas .apexcharts-datalabel,
.dark .apexcharts-canvas .apexcharts-datalabel-label,
.dark .apexcharts-canvas .apexcharts-datalabel-value {
    fill: #bfc9d4;
}

.dark .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {
    box-shadow: none;
}

.apexcharts-canvas .apexcharts-legend-marker:where([dir="ltr"], [dir="ltr"] *){
  margin-right: 0.375rem !important;
}

.apexcharts-canvas .apexcharts-legend-marker:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 0.375rem;
  margin-right: 0px !important;
}

[dir='rtl'] .apexcharts-tooltip-marker{
  margin-right: 0px;
  margin-left: 0.625rem;
}

/* Animations */
.slide-down-enter-active{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.slide-down-leave-active{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 75ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.slide-down-enter-from,
.slide-down-leave-to{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 0;
}
.slide-down-enter-to,
.slide-down-leave-from{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 1;
}

.modal-fade-enter-active{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.modal-fade-leave-active{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.modal-fade-enter-from,
.modal-fade-leave-to{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 0;
}
.modal-fade-enter-to,
.modal-fade-leave-from{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  opacity: 1;
}

/* Hightlight JS */
pre.hljs{
  overflow-x: auto;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(25 30 58 / var(--tw-bg-opacity, 1)) !important;
  padding: 1.5rem;
}

/* Styling tambahan untuk DataTable */
.dataTable-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dataTable-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-top: 1px solid #ddd;
}

.dataTable-pagination {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
}

.dark\\:btn-dark:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(59 63 92 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(59 63 92 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow-color: rgb(59 63 92 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}

.before\\:inline-block::before{
  content: var(--tw-content);
  display: inline-block;
}

.before\\:h-1\\.5::before{
  content: var(--tw-content);
  height: 0.375rem;
}

.before\\:w-1\\.5::before{
  content: var(--tw-content);
  width: 0.375rem;
}

.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-white::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.before\\:content-\\[\\'\\/\\'\\]::before{
  --tw-content: '/';
  content: var(--tw-content);
}

.even\\:bg-gray-50:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:border-primary:hover{
  --tw-border-opacity: 1;
  border-color: rgb(67 97 238 / var(--tw-border-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-500\\/10:hover{
  background-color: rgb(107 114 128 / 0.1);
}

.hover\\:bg-primary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white-light\\/90:hover{
  background-color: rgb(224 230 237 / 0.9);
}

.hover\\:\\!text-primary:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(14 23 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-dark:hover{
  --tw-text-opacity: 1;
  color: rgb(59 63 92 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-400:hover{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary:hover{
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:\\!text-primary{
  --tw-text-opacity: 1 !important;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1)) !important;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:saturate-100{
  --tw-saturate: saturate(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.dark\\:\\!border-\\[\\#191e3a\\]:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(25 30 58 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:border-\\[\\#191e3a\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(25 30 58 / var(--tw-border-opacity, 1));
}

.dark\\:border-\\[\\#1b2e4b\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(27 46 75 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-white:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.dark\\:border-white-light\\/10:is(.dark *){
  border-color: rgb(224 230 237 / 0.1);
}

.dark\\:border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:\\!border-b-black:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-bottom-color: rgb(14 23 38 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:bg-\\[\\#060818\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(6 8 24 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#121c2c\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(18 28 44 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#1b2e4b\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(27 46 75 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-black:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(14 23 38 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-danger:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(231 81 90 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-dark:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(59 63 92 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-dark\\/40:is(.dark *){
  background-color: rgb(59 63 92 / 0.4);
}

.dark\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-info:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-primary:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-secondary:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(128 93 202 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-success:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 171 85 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-warning:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(226 160 63 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:bg-opacity-\\[0\\.08\\]:is(.dark *){
  --tw-bg-opacity: 0.08;
}

.dark\\:text-\\[\\#506690\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(80 102 144 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#bfc9d4\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 201 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#d0d2d6\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(208 210 214 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#ffeccb\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 236 203 / var(--tw-text-opacity, 1));
}

.dark\\:text-danger-light:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 245 245 / var(--tw-text-opacity, 1));
}

.dark\\:text-dark:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(59 63 92 / var(--tw-text-opacity, 1));
}

.dark\\:text-dark-light\\/60:is(.dark *){
  color: rgb(234 234 236 / 0.6);
}

.dark\\:text-gray-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-info-light:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(231 247 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-primary-light:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(234 241 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-secondary-light:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(235 228 247 / var(--tw-text-opacity, 1));
}

.dark\\:text-success-light:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(221 245 240 / var(--tw-text-opacity, 1));
}

.dark\\:text-warning-light:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 249 237 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-white-dark:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}

.dark\\:text-white-dark\\/70:is(.dark *){
  color: rgb(136 142 168 / 0.7);
}

.dark\\:text-white-light:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(224 230 237 / var(--tw-text-opacity, 1));
}

.dark\\:text-white-light\\/90:is(.dark *){
  color: rgb(224 230 237 / 0.9);
}

.dark\\:text-white\\/70:is(.dark *){
  color: rgb(255 255 255 / 0.7);
}

.dark\\:ring-white-dark:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(136 142 168 / var(--tw-ring-opacity, 1));
}

.dark\\:hover\\:border-b-black:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-bottom-color: rgb(14 23 38 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:bg-dark-light\\/10:hover:is(.dark *){
  background-color: rgb(234 234 236 / 0.1);
}

.dark\\:hover\\:bg-dark\\/60:hover:is(.dark *){
  background-color: rgb(59 63 92 / 0.6);
}

.dark\\:hover\\:bg-primary:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(67 97 238 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:text-gray-600:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-primary:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(67 97 238 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white-light\\/90:hover:is(.dark *){
  color: rgb(224 230 237 / 0.9);
}

.group:hover .dark\\:group-hover\\:bg-transparent:is(.dark *){
  background-color: transparent;
}

.group:hover .dark\\:group-hover\\:text-white-dark:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(136 142 168 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px){

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:max-w-6xl{
    max-width: 72rem;
  }

  .sm\\:flex-1{
    flex: 1 1 0%;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

@media (min-width: 768px){

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:h-\\[550px\\]{
    height: 550px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 1024px){

  .lg\\:inline{
    display: inline;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
}

@media (min-width: 1280px){

  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.ltr\\:\\!right-0:where([dir="ltr"], [dir="ltr"] *){
  right: 0px !important;
}

.ltr\\:-left-12:where([dir="ltr"], [dir="ltr"] *){
  left: -3rem;
}

.ltr\\:-right-\\[400px\\]:where([dir="ltr"], [dir="ltr"] *){
  right: -400px;
}

.ltr\\:left-2:where([dir="ltr"], [dir="ltr"] *){
  left: 0.5rem;
}

.ltr\\:left-3:where([dir="ltr"], [dir="ltr"] *){
  left: 0.75rem;
}

.ltr\\:right-0:where([dir="ltr"], [dir="ltr"] *){
  right: 0px;
}

.ltr\\:right-2:where([dir="ltr"], [dir="ltr"] *){
  right: 0.5rem;
}

.ltr\\:right-6:where([dir="ltr"], [dir="ltr"] *){
  right: 1.5rem;
}

.ltr\\:-ml-1:where([dir="ltr"], [dir="ltr"] *){
  margin-left: -0.25rem;
}

.ltr\\:-mr-3:where([dir="ltr"], [dir="ltr"] *){
  margin-right: -0.75rem;
}

.ltr\\:ml-1:where([dir="ltr"], [dir="ltr"] *){
  margin-left: 0.25rem;
}

.ltr\\:ml-1\\.5:where([dir="ltr"], [dir="ltr"] *){
  margin-left: 0.375rem;
}

.ltr\\:ml-2:where([dir="ltr"], [dir="ltr"] *){
  margin-left: 0.5rem;
}

.ltr\\:ml-4:where([dir="ltr"], [dir="ltr"] *){
  margin-left: 1rem;
}

.ltr\\:ml-auto:where([dir="ltr"], [dir="ltr"] *){
  margin-left: auto;
}

.ltr\\:mr-1:where([dir="ltr"], [dir="ltr"] *){
  margin-right: 0.25rem;
}

.ltr\\:mr-2:where([dir="ltr"], [dir="ltr"] *){
  margin-right: 0.5rem;
}

.ltr\\:mr-3:where([dir="ltr"], [dir="ltr"] *){
  margin-right: 0.75rem;
}

.ltr\\:mr-4:where([dir="ltr"], [dir="ltr"] *){
  margin-right: 1rem;
}

.ltr\\:rounded-l-md:where([dir="ltr"], [dir="ltr"] *){
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.ltr\\:rounded-r-md:where([dir="ltr"], [dir="ltr"] *){
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.ltr\\:rounded-bl-full:where([dir="ltr"], [dir="ltr"] *){
  border-bottom-left-radius: 9999px;
}

.ltr\\:rounded-tl-full:where([dir="ltr"], [dir="ltr"] *){
  border-top-left-radius: 9999px;
}

.ltr\\:pl-10:where([dir="ltr"], [dir="ltr"] *){
  padding-left: 2.5rem;
}

.ltr\\:pl-3:where([dir="ltr"], [dir="ltr"] *){
  padding-left: 0.75rem;
}

.ltr\\:pl-4:where([dir="ltr"], [dir="ltr"] *){
  padding-left: 1rem;
}

.ltr\\:pr-3:where([dir="ltr"], [dir="ltr"] *){
  padding-right: 0.75rem;
}

.ltr\\:pr-4:where([dir="ltr"], [dir="ltr"] *){
  padding-right: 1rem;
}

.ltr\\:text-right:where([dir="ltr"], [dir="ltr"] *){
  text-align: right;
}

.ltr\\:before\\:mr-2:where([dir="ltr"], [dir="ltr"] *)::before{
  content: var(--tw-content);
  margin-right: 0.5rem;
}

@media (min-width: 640px){

  .ltr\\:sm\\:ml-0:where([dir="ltr"], [dir="ltr"] *){
    margin-left: 0px;
  }

  .sm\\:ltr\\:mr-auto:where([dir="ltr"], [dir="ltr"] *){
    margin-right: auto;
  }

  .ltr\\:sm\\:text-left:where([dir="ltr"], [dir="ltr"] *){
    text-align: left;
  }
}

.rtl\\:\\!left-0:where([dir="rtl"], [dir="rtl"] *){
  left: 0px !important;
}

.rtl\\:-left-\\[400px\\]:where([dir="rtl"], [dir="rtl"] *){
  left: -400px;
}

.rtl\\:-right-12:where([dir="rtl"], [dir="rtl"] *){
  right: -3rem;
}

.rtl\\:left-0:where([dir="rtl"], [dir="rtl"] *){
  left: 0px;
}

.rtl\\:left-2:where([dir="rtl"], [dir="rtl"] *){
  left: 0.5rem;
}

.rtl\\:left-6:where([dir="rtl"], [dir="rtl"] *){
  left: 1.5rem;
}

.rtl\\:right-2:where([dir="rtl"], [dir="rtl"] *){
  right: 0.5rem;
}

.rtl\\:right-3:where([dir="rtl"], [dir="rtl"] *){
  right: 0.75rem;
}

.rtl\\:-ml-3:where([dir="rtl"], [dir="rtl"] *){
  margin-left: -0.75rem;
}

.rtl\\:-mr-1:where([dir="rtl"], [dir="rtl"] *){
  margin-right: -0.25rem;
}

.rtl\\:ml-1:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 0.25rem;
}

.rtl\\:ml-1\\.5:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 0.375rem;
}

.rtl\\:ml-2:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 0.5rem;
}

.rtl\\:ml-3:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 0.75rem;
}

.rtl\\:ml-4:where([dir="rtl"], [dir="rtl"] *){
  margin-left: 1rem;
}

.rtl\\:mr-1:where([dir="rtl"], [dir="rtl"] *){
  margin-right: 0.25rem;
}

.rtl\\:mr-1\\.5:where([dir="rtl"], [dir="rtl"] *){
  margin-right: 0.375rem;
}

.rtl\\:mr-2:where([dir="rtl"], [dir="rtl"] *){
  margin-right: 0.5rem;
}

.rtl\\:mr-4:where([dir="rtl"], [dir="rtl"] *){
  margin-right: 1rem;
}

.rtl\\:mr-auto:where([dir="rtl"], [dir="rtl"] *){
  margin-right: auto;
}

.rtl\\:-rotate-90:where([dir="rtl"], [dir="rtl"] *){
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *){
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:rotate-90:where([dir="rtl"], [dir="rtl"] *){
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}

.rtl\\:rounded-l-md:where([dir="rtl"], [dir="rtl"] *){
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.rtl\\:rounded-r-md:where([dir="rtl"], [dir="rtl"] *){
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.rtl\\:rounded-br-full:where([dir="rtl"], [dir="rtl"] *){
  border-bottom-right-radius: 9999px;
}

.rtl\\:rounded-tr-full:where([dir="rtl"], [dir="rtl"] *){
  border-top-right-radius: 9999px;
}

.rtl\\:pl-3:where([dir="rtl"], [dir="rtl"] *){
  padding-left: 0.75rem;
}

.rtl\\:pl-4:where([dir="rtl"], [dir="rtl"] *){
  padding-left: 1rem;
}

.rtl\\:pr-10:where([dir="rtl"], [dir="rtl"] *){
  padding-right: 2.5rem;
}

.rtl\\:pr-3:where([dir="rtl"], [dir="rtl"] *){
  padding-right: 0.75rem;
}

.rtl\\:pr-4:where([dir="rtl"], [dir="rtl"] *){
  padding-right: 1rem;
}

.rtl\\:text-left:where([dir="rtl"], [dir="rtl"] *){
  text-align: left;
}

.rtl\\:before\\:ml-2:where([dir="rtl"], [dir="rtl"] *)::before{
  content: var(--tw-content);
  margin-left: 0.5rem;
}

.group:hover .rtl\\:group-hover\\:-translate-x-1:where([dir="rtl"], [dir="rtl"] *){
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 640px){

  .sm\\:rtl\\:ml-auto:where([dir="rtl"], [dir="rtl"] *){
    margin-left: auto;
  }

  .sm\\:rtl\\:mr-0:where([dir="rtl"], [dir="rtl"] *){
    margin-right: 0px;
  }

  .rtl\\:sm\\:text-right:where([dir="rtl"], [dir="rtl"] *){
    text-align: right;
  }
}
`, "",{"version":3,"sources":["webpack://./src/tailwind.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,qBAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,qBAAA;AAAc;;AAAd,kEAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AACd;EAAA,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,mBAAoB;EAApB,4CAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,iFAAoB;EAApB,qBAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,UAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,UAAA;AAAoB;AAApB;EAAA,UAAA;AAAoB;AAApB;EAAA,iBAAoB;EAApB,mBAAA;AAAoB;AAApB;EAAA,oBAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,iBAAA;AAAoB;AAApB;EAAA,yDAAoB;EAApB,wCAAoB;EAApB,4BAAoB;EAApB,4BAAoB;EAApB,qBAAoB;EAApB,iCAAoB;UAApB,yBAAA;AAAoB;AAApB;EAAA,yBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,sBAAoB;EAApB,iCAAoB;UAApB,yBAAA;AAAoB;AAApB;EAAA,wBAAoB;KAApB,qBAAoB;UAApB,gBAAoB;EAApB,UAAoB;EAApB,iCAAoB;UAApB,yBAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,6BAAoB;EAApB,yBAAoB;KAApB,sBAAoB;UAApB,iBAAoB;EAApB,cAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,cAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,sBAAA;AAAoB;AAApB;EAAA,kBAAA;AAAoB;AAApB;EAAA,mBAAA;AAAoB;AAApB;EAAA,8BAAoB;EAApB,mBAAoB;EAApB,4CAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,iFAAA;AAAoB;AAApB;EAAA,yBAAoB;EAApB,8BAAoB;EAApB,0BAAoB;EAApB,2BAAoB;EAApB,4BAAA;AAAoB;AAApB;EAAA,yDAAoB;AAAA;AAApB;;EAAA;IAAA,wBAAoB;OAApB,qBAAoB;YAApB,gBAAA;EAAoB;AAAA;AAApB;EAAA,yDAAoB;AAAA;AAApB;;EAAA;IAAA,wBAAoB;OAApB,qBAAoB;YAApB,gBAAA;EAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,8BAAA;AAAoB;AAApB;EAAA,yDAAoB;EAApB,yBAAoB;EAApB,8BAAoB;EAApB,0BAAoB;EAApB,2BAAoB;EAApB,4BAAoB;AAAA;AAApB;;EAAA;IAAA,wBAAoB;OAApB,qBAAoB;YAApB,gBAAA;EAAoB;AAAA;AAApB;EAAA,yBAAoB;EAApB,8BAAA;AAAoB;AAKZ;EAAA,uBAAA;AAAoB;AAIpB;EAAA,kBAA+B;EAA/B,4DAA+B;EAA/B,+BAAA;AAA+B;AAI/B;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAGvB,UAAU;AAEN;EAAA,kBAA4D;EAA5D,uBAA4D;EAA5D,kBAA4D;EAA5D,4DAA4D;EAA5D,gBAA4D;EAA5D,0EAA4D;EAA5D,8FAA4D;EAA5D,uGAAA;AAA4D;AAA5D;EAAA,kBAA4D;EAA5D,yDAAA;AAA4D;AAEhE,WAAW;AAGP;;EAAA,gBAAwB;EAAxB,QAAwB;EAAxB,WAAA;AAAwB;AAGxB;EAAA,wCAAqD;EAArD,oBAAqD;EAArD,qBAAqD;EAArD,iBAAA;AAAqD;AAArD;EAAA,mCAAA;AAAqD;AAGrD;EAAA,oCAA0B;EAA1B,mCAA0B;EAA1B,0EAA0B;EAA1B,8FAA0B;EAA1B,uGAAA;AAA0B;AAG9B,YAAY;AAER;EAAA,WAAA;AAAa;AAKb;;EAAA,sBAAiN;EAAjN,aAAiN;EAAjN,WAAiN;EAAjN,mBAAiN;EAAjN,8BAAiN;EAAjN,gBAAiN;EAAjN,mBAAiN;EAAjN,uBAAiN;EAAjN,iBAAiN;EAAjN,oBAAiN;EAAjN,kDAAA;AAAiN;AAAjN;;EAAA,mCAAiN;EAAjN,oBAAiN;EAAjN,gDAAA;AAAiN;AAAjN;;EAAA,kBAAiN;EAAjN,yDAAiN;EAAjN,oBAAiN;EAAjN,mDAAA;AAAiN;AAIjN;;EAAA,mCAAyE;EAAzE,oBAAyE;EAAzE,gDAAA;AAAyE;AAAzE;;EAAA,kBAAyE;EAAzE,yDAAyE;EAAzE,oBAAyE;EAAzE,mDAAA;AAAyE;AAKzE;;EAAA,+BAA4B;EAA5B,8DAAA;AAA4B;AAK5B;;EAAA,aACgJ;EADhJ,mBACgJ;EADhJ,qBACgJ;EADhJ,sBACgJ;EADhJ,qBACgJ;EADhJ,wBAAA;AACgJ;AADhJ;;EAAA,gBACgJ;EADhJ,aACgJ;EADhJ,sBACgJ;EADhJ,0BACgJ;EADhJ,kBACgJ;EADhJ,4DAAA;AACgJ;AADhJ;;EAAA,kBACgJ;EADhJ,4DACgJ;EADhJ,oBACgJ;EADhJ,iDAAA;AACgJ;AADhJ;;EAAA,qCACgJ;EADhJ,6BACgJ;EADhJ,qEAAA;AACgJ;AADhJ;;EAAA,0BACgJ;EADhJ,kBACgJ;EADhJ,4DAAA;AACgJ;AADhJ;;EAAA,kBACgJ;EADhJ,yDACgJ;EADhJ,oBACgJ;EADhJ,iDAAA;AACgJ;AADhJ;;EAAA,0BACgJ;EADhJ,oBAAA;AACgJ;AADhJ;;EAAA,0BACgJ;EADhJ,mBAAA;AACgJ;AAIhJ;;EAAA,oBAAqC;EAArC,iDAAA;AAAqC;AAArC;;EAAA,0BAAqC;EAArC,kBAAqC;EAArC,0DAAA;AAAqC;AAKrC;;EAAA,eAA+C;EAA/C,cAA+C;EAA/C,0BAAA;AAA+C;AAA/C;;EAAA,6BAAA;AAA+C;AAI/C;EAAA,wBAAsE;EAAtE,wDAAsE;EAAtE,0BAAA;AAAsE;AAAtE;;EAAA;IAAA,kBAAA;EAAsE;;EAAtE;IAAA,mBAAA;EAAsE;AAAA;AAG1E,uBAAuB;AAEnB;EAAA,aAA+B;EAA/B,6EAA+B;EAA/B,iGAA+B;EAA/B,uGAAA;AAA+B;AAA/B;;EAAA;IAAA,aAAA;EAA+B;AAAA;AAG/B;EAAA,aAAA;AAAW;AAGX;EAAA,gBAAA;AAAwB;AAAxB;EAAA,iBAAA;AAAwB;AAGxB;EAAA,YAAA;AAA2C;AAA3C;EAAA,aAAA;AAA2C;AAG3C;EAAA,SAAA;AAAwE;AAAxE;;EAAA;IAAA,YAAA;EAAwE;AAAA;AAAxE;EAAA,UAAA;AAAwE;AAAxE;;EAAA;IAAA,aAAA;EAAwE;AAAA;AAKxE;;EAAA,eAA+C;EAA/C,cAA+C;EAA/C,0BAAA;AAA+C;AAA/C;;EAAA,6BAAA;AAA+C;AAK/C;;EAAA,6BAAA;AAAoB;AAIpB;EAAA,aAAkJ;EAAlJ,mBAAkJ;EAAlJ,qBAAkJ;EAAlJ,qBAAkJ;EAAlJ,wBAAkJ;EAAlJ,oBAAkJ;EAAlJ,qBAAA;AAAkJ;AAAlJ;EAAA,mCAAkJ;EAAlJ,oBAAkJ;EAAlJ,gDAAA;AAAkJ;AAAlJ;EAAA,kBAAkJ;EAAlJ,yDAAkJ;EAAlJ,oBAAkJ;EAAlJ,mDAAA;AAAkJ;AAAlJ;;EAAA;IAAA,kBAAkJ;IAAlJ,mBAAA;EAAkJ;AAAA;AAIlJ;EAAA,mCAAyE;EAAzE,oBAAyE;EAAzE,gDAAA;AAAyE;AAAzE;EAAA,kBAAyE;EAAzE,yDAAyE;EAAzE,oBAAyE;EAAzE,mDAAA;AAAyE;AAIzE;EAAA,kBAAsI;EAAtI,SAAsI;EAAtI,WAAsI;EAAtI,aAAsI;EAAtI,gBAAsI;EAAtI,sBAAsI;EAAtI,kBAAsI;EAAtI,4DAAsI;EAAtI,YAAsI;EAAtI,mBAAsI;EAAtI,sBAAsI;EAAtI,oBAAsI;EAAtI,gDAAsI;EAAtI,0EAAsI;EAAtI,8FAAsI;EAAtI,uGAAA;AAAsI;AAAtI;EAAA,kBAAsI;EAAtI,yDAAsI;EAAtI,oBAAsI;EAAtI,mDAAA;AAAsI;AAKtI;;EAAA,aAAuH;EAAvH,WAAuH;EAAvH,mBAAuH;EAAvH,8BAAuH;EAAvH,kBAAuH;EAAvH,mBAAuH;EAAvH,mBAAuH;EAAvH,sBAAA;AAAuH;AAAvH;;EAAA,kBAAuH;EAAvH,4DAAuH;EAAvH,oBAAuH;EAAvH,iDAAA;AAAuH;AAAvH;;EAAA,sCAAA;AAAuH;AAKvH;;EAAA,kBAAkD;EAAlD,4DAAkD;EAAlD,oBAAkD;EAAlD,iDAAA;AAAkD;AAAlD;;EAAA,sCAAA;AAAkD;AAKlD;;EAAA,cAAA;AAAY;AAGhB,qBAAqB;AAGjB;;EAAA,aAAA;AAAW;AAGX;EAAA,gBAAA;AAAwB;AAAxB;EAAA,iBAAA;AAAwB;AAGxB;EAAA,YAAA;AAAwE;AAAxE;;EAAA;IAAA,SAAA;EAAwE;AAAA;AAAxE;EAAA,aAAA;AAAwE;AAAxE;;EAAA;IAAA,UAAA;EAAwE;AAAA;AAGxE;EAAA,SAAA;AAAwE;AAAxE;;EAAA;IAAA,YAAA;EAAwE;AAAA;AAAxE;EAAA,UAAA;AAAwE;AAAxE;;EAAA;IAAA,aAAA;EAAwE;AAAA;AAG5E,iCAAiC;AAE7B;EAAA,YAAA;AAAoG;AAApG;;EAAA;IAAA,WAAA;EAAoG;AAAA;AAApG;EAAA,YAAA;AAAoG;AAApG;;EAAA;IAAA,SAAA;EAAoG;AAAA;AAApG;EAAA,aAAA;AAAoG;AAApG;;EAAA;IAAA,UAAA;EAAoG;AAAA;AAGpG;EAAA,SAAA;AAA6B;AAA7B;EAAA,UAAA;AAA6B;AAG7B;;EAAA;IAAA,YAAA;EAAmB;AAAA;AAGnB;EAAA,WAAA;AAAa;AAGb;;EAAA;IAAA,yBAAA;EAAkE;;EAAlE;IAAA,kBAAA;EAAkE;;EAAlE;IAAA,mBAAA;EAAkE;;EAIlE;IAAA,aAAA;EAAgB;AAJkD;AASlE;;;EAAA,cAAA;AAAY;AAGZ;;EAAA;IAAA,wBAAA;EAA+D;;EAA/D;IAAA,iBAAA;EAA+D;;EAA/D;IAAA,kBAAA;EAA+D;AAAA;AAI/D;;EAAA,4BAAmD;EAAnD,wDAAmD;EAAnD,0BAAA;AAAmD;AAAnD;;EAAA;;IAAA,UAAA;EAAmD;AAAA;AAMnD;;;;EAAA,0BAAA;AAAkC;AAAlC;;EAAA;;;;IAAA,UAAA;EAAkC;AAAA;AAGlC;EAAA,aAAoB;EAApB,iBAAoB;EAApB,+LAAA;AAAoB;AAGpB;EAAA,aAAsB;EAAtB,mBAAsB;EAAtB,+LAAA;AAAsB;AAGtB;EAAA,aAA+B;EAA/B,mBAAA;AAA+B;AAG/B;EAAA,cAAA;AAAY;AAIZ;;EAAA,eAAA;AAAa;AAIb;;EAAA,aAAA;AAAa;AAGjB,iBAAiB;AAEb;EAAA,iBAA6B;EAA7B,kBAA6B;EAA7B,iBAAA;AAA6B;AAK7B;;EAAA,gBAAA;AAAyD;AAAzD;;EAAA;;IAAA,UAAA;EAAyD;;EAAzD;;IAAA,WAAA;EAAyD;;EAIzD;IAAA,UAAA;EAAa;AAJ4C;AAO7D,YAAY;AAER;EAAA,kBAAoL;EAApL,aAAoL;EAApL,mBAAoL;EAApL,uBAAoL;EAApL,uBAAoL;EAApL,iBAAoL;EAApL,qBAAoL;EAApL,sBAAoL;EAApL,mBAAoL;EAApL,sBAAoL;EAApL,mBAAoL;EAApL,oBAAoL;EAApL,gBAAoL;EAApL,8BAAoL;EAApL,6DAAoL;EAApL,uGAAoL;EAApL,8BAAoL;EAApL,mBAAoL;EAApL,gKAAoL;EAApL,wJAAoL;EAApL,iLAAoL;EAApL,wDAAoL;EAApL,0BAAA;AAAoL;AAApL;EAAA,sBAAoL;EAApL,8BAAoL;EAApL,uGAAA;AAAoL;AASpL;EAAA,mBAAoC;EAApC,YAAA;AAAoC;AAIpC;EAAA,sBAA6D;EAA7D,0DAA6D;EAA7D,kBAA6D;EAA7D,0DAA6D;EAA7D,oBAA6D;EAA7D,mDAA6D;EAA7D,uCAA6D;EAA7D,qCAAA;AAA6D;AAG7D;EAAA,sBAAgF;EAAhF,0DAAgF;EAAhF,oBAAgF;EAAhF,iDAAgF;EAAhF,sBAAgF;EAAhF,8BAAgF;EAAhF,uGAAA;AAAgF;AAAhF;EAAA,kBAAgF;EAAhF,0DAAgF;EAAhF,oBAAgF;EAAhF,mDAAA;AAAgF;AAIhF;EAAA,sBAAmE;EAAnE,2DAAmE;EAAnE,kBAAmE;EAAnE,2DAAmE;EAAnE,oBAAmE;EAAnE,mDAAmE;EAAnE,wCAAmE;EAAnE,qCAAA;AAAmE;AAOnE;EAAA,sBAA6D;EAA7D,yDAA6D;EAA7D,kBAA6D;EAA7D,yDAA6D;EAA7D,oBAA6D;EAA7D,mDAA6D;EAA7D,sCAA6D;EAA7D,qCAAA;AAA6D;AAO7D;EAAA,sBAA0D;EAA1D,0DAA0D;EAA1D,kBAA0D;EAA1D,0DAA0D;EAA1D,oBAA0D;EAA1D,mDAA0D;EAA1D,uCAA0D;EAA1D,qCAAA;AAA0D;AAG1D;EAAA,sBAA6E;EAA7E,0DAA6E;EAA7E,oBAA6E;EAA7E,iDAA6E;EAA7E,sBAA6E;EAA7E,8BAA6E;EAA7E,uGAAA;AAA6E;AAA7E;EAAA,kBAA6E;EAA7E,0DAA6E;EAA7E,oBAA6E;EAA7E,mDAAA;AAA6E;AAI7E;EAAA,sBAA6D;EAA7D,2DAA6D;EAA7D,kBAA6D;EAA7D,2DAA6D;EAA7D,oBAA6D;EAA7D,mDAA6D;EAA7D,wCAA6D;EAA7D,qCAAA;AAA6D;AAO7D;EAAA,sBAAoD;EAApD,2DAAoD;EAApD,kBAAoD;EAApD,2DAAoD;EAApD,oBAAoD;EAApD,mDAAoD;EAApD,wCAAoD;EAApD,qCAAA;AAAoD;AAOpD;EAAA,sBAAoD;EAApD,yDAAoD;EAApD,kBAAoD;EAApD,yDAAoD;EAApD,oBAAoD;EAApD,mDAAoD;EAApD,sCAAoD;EAApD,qCAAA;AAAoD;AAOxD,UAAU;AAEN;EAAA,kBAAmG;EAAnG,mBAAmG;EAAnG,sBAAmG;EAAnG,sBAAmG;EAAnG,iBAAmG;EAAnG,yBAAmG;EAAnG,oBAAmG;EAAnG,qBAAmG;EAAnG,qBAAmG;EAAnG,wBAAmG;EAAnG,kBAAmG;EAAnG,iBAAmG;EAAnG,gBAAmG;EAAnG,oBAAmG;EAAnG,mDAAA;AAAmG;AAGnG;EAAA,sBAA2G;EAA3G,0DAA2G;EAA3G,oBAA2G;EAA3G,iDAAA;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G,4DAAA;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G,0DAA2G;EAA3G,oBAA2G;EAA3G,mDAAA;AAA2G;AAG3G;EAAA,sBAAmH;EAAnH,2DAAmH;EAAnH,oBAAmH;EAAnH,kDAAA;AAAmH;AAAnH;EAAA,kBAAmH;EAAnH,4DAAA;AAAmH;AAAnH;EAAA,kBAAmH;EAAnH,2DAAmH;EAAnH,oBAAmH;EAAnH,mDAAA;AAAmH;AAGnH;EAAA,sBAA2G;EAA3G,yDAA2G;EAA3G,oBAA2G;EAA3G,gDAAA;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G,4DAAA;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G,yDAA2G;EAA3G,oBAA2G;EAA3G,mDAAA;AAA2G;AAG3G;EAAA,sBAAuG;EAAvG,0DAAuG;EAAvG,oBAAuG;EAAvG,iDAAA;AAAuG;AAAvG;EAAA,kBAAuG;EAAvG,4DAAA;AAAuG;AAAvG;EAAA,kBAAuG;EAAvG,0DAAuG;EAAvG,oBAAuG;EAAvG,mDAAA;AAAuG;AAGvG;EAAA,sBAA2G;EAA3G,2DAA2G;EAA3G,oBAA2G;EAA3G,kDAAA;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G,4DAAA;AAA2G;AAA3G;EAAA,kBAA2G;EAA3G,2DAA2G;EAA3G,oBAA2G;EAA3G,mDAAA;AAA2G;AAG3G;EAAA,sBAA+F;EAA/F,2DAA+F;EAA/F,oBAA+F;EAA/F,kDAAA;AAA+F;AAA/F;EAAA,kBAA+F;EAA/F,4DAAA;AAA+F;AAA/F;EAAA,kBAA+F;EAA/F,2DAA+F;EAA/F,oBAA+F;EAA/F,mDAAA;AAA+F;AAG/F;EAAA,sBAA+F;EAA/F,yDAA+F;EAA/F,oBAA+F;EAA/F,gDAAA;AAA+F;AAA/F;EAAA,kBAA+F;EAA/F,4DAAA;AAA+F;AAA/F;EAAA,kBAA+F;EAA/F,yDAA+F;EAA/F,oBAA+F;EAA/F,mDAAA;AAA+F;AAGnG,SAAS;AAKL;;;;EAAA,WAAuP;EAAvP,uBAAuP;EAAvP,iBAAuP;EAAvP,sBAAuP;EAAvP,4DAAuP;EAAvP,kBAAuP;EAAvP,4DAAuP;EAAvP,kBAAuP;EAAvP,mBAAuP;EAAvP,mBAAuP;EAAvP,sBAAuP;EAAvP,mBAAuP;EAAvP,oBAAuP;EAAvP,gBAAuP;EAAvP,oBAAuP;EAAvP,gDAAuP;EAAvP,yCAAuP;EAAvP,8BAAA;AAAuP;AAAvP;;;;EAAA,sBAAuP;EAAvP,0DAAuP;EAAvP,4BAAA;AAAuP;AAAvP;;;;EAAA,sBAAuP;EAAvP,yDAAuP;EAAvP,kBAAuP;EAAvP,yDAAuP;EAAvP,oBAAuP;EAAvP,mDAAA;AAAuP;AAAvP;;;;EAAA,sBAAuP;EAAvP,0DAAA;AAAuP;AAgBvP;EAAA,uBAAiC;EAAjC,cAAiC;EAAjC,gBAAA;AAAiC;AAErC;QACI,uCAAuC;IAC3C;AAOI;;;;;EAAA,sBAA2F;EAA3F,0DAA2F;EAA3F,uCAA2F;EAA3F,oBAA2F;EAA3F,iDAAA;AAA2F;AAA3F;EAAA,2BAAA;AAA2F;AAA3F;;;;;EAAA,2BAAA;AAA2F;AAA3F;;;;;EAAA,sBAA2F;EAA3F,0DAAA;AAA2F;AAa3F;;EAAA,sBAAoB;EAApB,0DAAA;AAAoB;AAQpB;;;;;EAAA,sBAAgG;EAAhG,yDAAgG;EAAhG,sCAAgG;EAAhG,oBAAgG;EAAhG,gDAAA;AAAgG;AAAhG;EAAA,0BAAA;AAAgG;AAAhG;;;;;EAAA,0BAAA;AAAgG;AAAhG;;;;;EAAA,sBAAgG;EAAhG,yDAAA;AAAgG;AAepG,qBAAqB;AAGjB;;EAAA,eAC8E;EAD9E,cAC8E;EAD9E,eAC8E;EAD9E,sBAC8E;EAD9E,iBAC8E;EAD9E,sBAC8E;EAD9E,4DAC8E;EAD9E,6BAC8E;EAD9E,oBAC8E;EAD9E,iDAC8E;EAD9E,iCAC8E;EAD9E,yCAC8E;EAD9E,kHAC8E;EAD9E,yCAC8E;EAD9E,8BAC8E;EAD9E,sHAC8E;EAD9E,oHAC8E;EAD9E,uGAC8E;EAD9E,sCAAA;AAC8E;AAD9E;;EAAA,wBAAA;AAC8E;AAD9E;;EAAA,mBAC8E;EAD9E,kBAC8E;EAD9E,4DAAA;AAC8E;AAD9E;;EAAA,sBAC8E;EAD9E,yDAAA;AAC8E;AAD9E;;EAAA,yBAAA;AAC8E;AAD9E;;EAAA,kBAC8E;EAD9E,yDAAA;AAC8E;AAD9E;;EAAA,sBAAA;AAC8E;AAD9E;;EAAA,qBAAA;AAC8E;AAI9E;EAAA,sBAAoC;EAApC,0DAAoC;EAApC,6BAAoC;QACpC,yDAAA;AADoC;AAIpC;EAAA,sBAAsC;EAAtC,2DAAsC;EAAtC,6BAAsC;QACtC,yDAAA;AADsC;AAItC;EAAA,sBAAoC;EAApC,yDAAoC;EAApC,6BAAoC;QACpC,yDAAA;AADoC;AAIpC;EAAA,sBAAmC;EAAnC,0DAAmC;EAAnC,6BAAmC;QACnC,yDAAA;AADmC;AAInC;EAAA,sBAAoC;EAApC,2DAAoC;EAApC,6BAAoC;QACpC,yDAAA;AADoC;AAIpC;EAAA,sBAAiC;EAAjC,2DAAiC;EAAjC,6BAAiC;QACjC,yDAAA;AADiC;AAIjC;EAAA,sBAAiC;EAAjC,yDAAiC;EAAjC,6BAAiC;QACjC,0DAAA;AADiC;AAKjC;EAAA,qBAAA;AAAmB;AAInB;EAAA,sBAA4C;EAA5C,0DAA4C;EAA5C,6BAA4C;EAA5C,sBAAA;AAA4C;AAG5C;EAAA,sBAA8C;EAA9C,2DAA8C;EAA9C,6BAA8C;EAA9C,sBAAA;AAA8C;AAG9C;EAAA,sBAA4C;EAA5C,yDAA4C;EAA5C,6BAA4C;EAA5C,sBAAA;AAA4C;AAG5C;EAAA,sBAA2C;EAA3C,0DAA2C;EAA3C,6BAA2C;EAA3C,sBAAA;AAA2C;AAG3C;EAAA,sBAA4C;EAA5C,2DAA4C;EAA5C,6BAA4C;EAA5C,sBAAA;AAA4C;AAG5C;EAAA,sBAAyC;EAAzC,2DAAyC;EAAzC,6BAAyC;EAAzC,sBAAA;AAAyC;AAGzC;EAAA,sBAAyC;EAAzC,yDAAyC;EAAzC,6BAAyC;EAAzC,sBAAA;AAAyC;AAG7C,aAAa;AAET;EAAA,kBAAA;AAAe;AAGf;EAAA,aAAA;AAAW;AAGX;EAAA,mBAA4G;EAA5G,sBAA4G;EAA5G,gBAA4G;EAA5G,sBAA4G;EAA5G,kBAA4G;EAA5G,4DAA4G;EAA5G,YAA4G;EAA5G,mBAA4G;EAA5G,sBAA4G;EAA5G,oBAA4G;EAA5G,gDAA4G;EAA5G,0EAA4G;EAA5G,8FAA4G;EAA5G,uGAAA;AAA4G;AAA5G;EAAA,kBAA4G;EAA5G,yDAA4G;EAA5G,oBAA4G;EAA5G,mDAAA;AAA4G;AAI5G;;EAAA,aAAyE;EAAzE,mBAAyE;EAAzE,kBAAyE;EAAzE,mBAAyE;EAAzE,mBAAyE;EAAzE,sBAAA;AAAyE;AAAzE;;EAAA,sCAAyE;EAAzE,oBAAyE;EAAzE,iDAAA;AAAyE;AAGzE;EAAA,WAAA;AAAa;AAGjB,WAAW;AAEP;EAAA,cAAA;AAAoB;AAGpB;EAAA,WAA8B;EAA9B,oCAAA;AAA8B;AAI9B;;EAAA,wBAAuD;EAAvD,wCAAA;AAAuD;AAAvD;;EAAA,6BAAuD;EAAvD,oEAAA;AAAuD;AAKvD;;;EAAA,oBAA6C;EAA7C,uBAA6C;EAA7C,kBAA6C;EAA7C,mBAAA;AAA6C;AAA7C;;;EAAA,gBAAA;AAA6C;AAA7C;;;EAAA,iBAAA;AAA6C;AAI7C;;EAAA,gBAAA;AAAoB;AAGpB;EAAA,wBAA6D;EAA7D,+CAAA;AAA6D;AAA7D;EAAA,iCAA6D;EAA7D,oEAAA;AAA6D;AAiBjE,oBAAoB;AACpB;QACI,cAAc;IAClB;AA1eJ;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,+LAAA;AAAmB;AAAnB;;EAAA;IAAA,yBAAA;EAAmB;AAAA;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;;EAAA;IAAA,WAAA;EAAmB;AAAA;AAAnB;EAAA,yDAAA;AAAmB;AAAnB;;EAAA;IAAA,yBAAA;EAAmB;AAAA;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB,iEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,+DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,gEAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB,6DAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB,qDAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,uEAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,oCAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,8EAAA;AAAmB;AAAnB;EAAA,yCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,2DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,0DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,2DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,2DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,qEAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB,mEAAA;AAAmB;AAAnB;EAAA,wDAAA;AAAmB;AAAnB;EAAA,wDAAA;AAAmB;AAAnB;EAAA,wDAAA;AAAmB;AAAnB;EAAA,wDAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB,iBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,kDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,wDAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,4FAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6DAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,iLAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,iLAAA;AAAmB;AAAnB;EAAA,iLAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,sDAAA;AAAmB;AAAnB;EAAA,sDAAA;AAAmB;;AA6enB,sBAAsB;AAGlB;;EAAA,0BAA8C;EAA9C,6BAA8C;EAA9C,uEAAA;AAA8C;AAA9C;;EAAA,6BAA8C;EAA9C,oEAAA;AAA8C;AAQ9C;;;;;;EAAA,uBAAkB;EAQlB,wCAAA;AARkB;;AAWtB,UAAU;AAEN;EAAA,oBAAyD;EAAzD,mDAAA;AAAyD;AAAzD;EAAA,oBAAyD;EAAzD,mDAAA;AAAyD;AAAzD;EAAA,sBAAyD;EAAzD,8BAAyD;EAAzD,uGAAA;AAAyD;;AAIzD;EAAA,kBAA0B;EAA1B,yDAA0B;EAA1B,qBAA0B;EAA1B,wBAA0B;EAA1B,qBAA0B;EAA1B,sBAAA;AAA0B;;AAK1B;;EAAA,oBAAiB;EAAjB,mDAAA;AAAiB;AAGjB;EAAA,kBAAiB;EAAjB,0DAAA;AAAiB;;AAIjB;EAAA,kBAAmB;EAAnB,2DAAA;AAAmB;;AAInB;EAAA,kBAAiB;EAAjB,2DAAA;AAAiB;AAGjB;EAAA,kBAAc;EAAd,2DAAA;AAAc;AAGd;EAAA,kBAAgB;EAAhB,0DAAA;AAAgB;AAGhB;EAAA,kBAAiB;EAAjB,yDAAA;AAAiB;;AAGrB,eAAe;AACf;;IAEI,gBAAgB;IAChB,uBAAmD;IAAnD,2BAAmD;IAAnD,oBAAmD;IAAnD,mDAAmD;AACvD;;AAII;;EAAA,8BAAA;AAA2B;;AAI3B;EAAA,oBAAiB;EAAjB,mDAAA;AAAiB;;AAIjB;EAAA,sBAA+B;EAA/B,yDAA+B;EAA/B,kBAA+B;EAA/B,uDAAA;AAA+B;;AAI/B;EAAA,+BAAA;AAA0B;;AAA1B;EAAA,8BAAA;AAA0B;;AAG9B;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAGI;EAAA,iCAAA;AAAuC;;AAAvC;EAAA,qBAAuC;EAAvC,4BAAA;AAAuC;;AAIvC;EAAA,iBAAkB;EAAlB,qBAAA;AAAkB;;AAGtB,eAAe;AAEX;EAAA,gKAAuC;EAAvC,wJAAuC;EAAvC,iLAAuC;EAAvC,wDAAuC;EAAvC,0BAAuC;EAAvC,sDAAA;AAAuC;AAGvC;EAAA,gKAAqC;EAArC,wJAAqC;EAArC,iLAAqC;EAArC,wDAAqC;EAArC,yBAAqC;EAArC,sDAAA;AAAqC;AAIrC;;EAAA,iBAAmC;EAAnC,iBAAmC;EAAnC,+LAAmC;EAAnC,UAAA;AAAmC;AAInC;;EAAA,eAAsC;EAAtC,eAAsC;EAAtC,+LAAsC;EAAtC,UAAA;AAAsC;;AAItC;EAAA,gKAAuC;EAAvC,wJAAuC;EAAvC,iLAAuC;EAAvC,wDAAuC;EAAvC,0BAAuC;EAAvC,sDAAA;AAAuC;AAGvC;EAAA,gKAAsC;EAAtC,wJAAsC;EAAtC,iLAAsC;EAAtC,wDAAsC;EAAtC,0BAAsC;EAAtC,sDAAA;AAAsC;AAItC;;EAAA,iBAAmC;EAAnC,iBAAmC;EAAnC,+LAAmC;EAAnC,UAAA;AAAmC;AAInC;;EAAA,eAAsC;EAAtC,eAAsC;EAAtC,+LAAsC;EAAtC,UAAA;AAAsC;;AAG1C,kBAAkB;AAEd;EAAA,gBAAmD;EAAnD,uBAAmD;EAAnD,6BAAmD;EAAnD,oEAAmD;EAAnD,eAAA;AAAmD;;AAGvD,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AArZQ;EAAA,sBAAoD;EAApD,yDAAoD;EAApD,kBAAoD;EAApD,yDAAoD;EAApD,oBAAoD;EAApD,mDAAoD;EAApD,sCAAoD;EAApD,qCAAA;AAAoD;;AAjR5D;EAAA,0BAuqBA;EAvqBA,qBAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,gBAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,eAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,qBAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,kBAuqBA;EAvqBA,4DAAA;AAuqBA;;AAvqBA;EAAA,iBAuqBA;EAvqBA,0BAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,4DAAA;AAuqBA;;AAvqBA;EAAA,sBAuqBA;EAvqBA,0DAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,4DAAA;AAuqBA;;AAvqBA;EAAA,wCAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,0DAAA;AAuqBA;;AAvqBA;EAAA,wCAAA;AAuqBA;;AAvqBA;EAAA,+BAuqBA;EAvqBA,4DAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,gDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,gDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,iDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,+BAAA;AAuqBA;;AAvqBA;EAAA,UAAA;AAuqBA;;AAvqBA;EAAA,YAAA;AAuqBA;;AAvqBA;EAAA,yBAuqBA;EAvqBA,+LAAA;AAuqBA;;AAvqBA;EAAA,+BAuqBA;EAvqBA,4DAAA;AAuqBA;;AAvqBA;EAAA,UAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,iLAAA;AAuqBA;;AAvqBA;EAAA,iCAuqBA;EAvqBA,oEAAA;AAuqBA;;AAvqBA;EAAA,sBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,sBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,sBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,sBAuqBA;EAvqBA,4DAAA;AAuqBA;;AAvqBA;EAAA,oCAAA;AAuqBA;;AAvqBA;EAAA,oCAAA;AAuqBA;;AAvqBA;EAAA,iCAuqBA;EAvqBA,2EAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,uDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,0DAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,qCAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,2DAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,0DAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,2DAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,yDAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,2DAAA;AAuqBA;;AAvqBA;EAAA,wCAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,kDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,gDAAA;AAuqBA;;AAvqBA;EAAA,6BAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,6BAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,6BAAA;AAuqBA;;AAvqBA;EAAA,6BAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,6DAAA;AAuqBA;;AAvqBA;EAAA,sBAuqBA;EAvqBA,gEAAA;AAuqBA;;AAvqBA;EAAA,wCAAA;AAuqBA;;AAvqBA;EAAA,qCAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,0DAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,gDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,iDAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;EAAA,6BAAA;AAuqBA;;AAvqBA;EAAA,6BAAA;AAuqBA;;AAvqBA;EAAA,oBAuqBA;EAvqBA,mDAAA;AAuqBA;;AAvqBA;;EAAA;IAAA,4BAAA;EAuqBA;;EAvqBA;IAAA,gBAAA;EAuqBA;;EAvqBA;IAAA,YAAA;EAuqBA;;EAvqBA;IAAA,gDAAA;EAuqBA;;EAvqBA;IAAA,iBAuqBA;IAvqBA,iBAAA;EAuqBA;AAAA;;AAvqBA;;EAAA;IAAA,4BAAA;EAuqBA;;EAvqBA;IAAA,eAAA;EAuqBA;;EAvqBA;IAAA,aAAA;EAuqBA;;EAvqBA;IAAA,aAAA;EAuqBA;;EAvqBA;IAAA,gDAAA;EAuqBA;;EAvqBA;IAAA,gDAAA;EAuqBA;;EAvqBA;IAAA,mBAuqBA;IAvqBA,oBAAA;EAuqBA;AAAA;;AAvqBA;;EAAA;IAAA,eAAA;EAuqBA;;EAvqBA;IAAA,aAAA;EAuqBA;;EAvqBA;IAAA,gDAAA;EAuqBA;;EAvqBA;IAAA,uBAuqBA;IAvqBA,sDAuqBA;IAvqBA,+DAAA;EAuqBA;AAAA;;AAvqBA;;EAAA;IAAA,4BAAA;EAuqBA;;EAvqBA;IAAA,4BAAA;EAuqBA;;EAvqBA;IAAA,gDAAA;EAuqBA;AAAA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,WAAA;AAuqBA;;AAvqBA;EAAA,aAAA;AAuqBA;;AAvqBA;EAAA,YAAA;AAuqBA;;AAvqBA;EAAA,aAAA;AAuqBA;;AAvqBA;EAAA,UAAA;AAuqBA;;AAvqBA;EAAA,aAAA;AAuqBA;;AAvqBA;EAAA,aAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,sBAAA;AAuqBA;;AAvqBA;EAAA,oBAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,mBAAA;AAuqBA;;AAvqBA;EAAA,iBAAA;AAuqBA;;AAvqBA;EAAA,iBAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,oBAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,kBAAA;AAuqBA;;AAvqBA;EAAA,gCAuqBA;EAvqBA,mCAAA;AAuqBA;;AAvqBA;EAAA,iCAuqBA;EAvqBA,oCAAA;AAuqBA;;AAvqBA;EAAA,iCAAA;AAuqBA;;AAvqBA;EAAA,8BAAA;AAuqBA;;AAvqBA;EAAA,oBAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,kBAAA;AAuqBA;;AAvqBA;EAAA,sBAAA;AAuqBA;;AAvqBA;EAAA,mBAAA;AAuqBA;;AAvqBA;EAAA,iBAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,oBAAA;AAuqBA;;AAvqBA;;EAAA;IAAA,gBAAA;EAuqBA;;EAvqBA;IAAA,kBAAA;EAuqBA;;EAvqBA;IAAA,gBAAA;EAuqBA;AAAA;;AAvqBA;EAAA,oBAAA;AAuqBA;;AAvqBA;EAAA,YAAA;AAuqBA;;AAvqBA;EAAA,YAAA;AAuqBA;;AAvqBA;EAAA,SAAA;AAuqBA;;AAvqBA;EAAA,YAAA;AAuqBA;;AAvqBA;EAAA,YAAA;AAuqBA;;AAvqBA;EAAA,aAAA;AAuqBA;;AAvqBA;EAAA,cAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,sBAAA;AAuqBA;;AAvqBA;EAAA,oBAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,mBAAA;AAuqBA;;AAvqBA;EAAA,oBAAA;AAuqBA;;AAvqBA;EAAA,iBAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,sBAAA;AAuqBA;;AAvqBA;EAAA,oBAAA;AAuqBA;;AAvqBA;EAAA,kBAAA;AAuqBA;;AAvqBA;EAAA,kBAAA;AAuqBA;;AAvqBA;EAAA,mBAuqBA;EAvqBA,+LAAA;AAuqBA;;AAvqBA;EAAA,mBAuqBA;EAvqBA,+LAAA;AAuqBA;;AAvqBA;EAAA,kBAuqBA;EAvqBA,+LAAA;AAuqBA;;AAvqBA;EAAA,uBAAA;AAuqBA;;AAvqBA;EAAA,gCAuqBA;EAvqBA,mCAAA;AAuqBA;;AAvqBA;EAAA,iCAuqBA;EAvqBA,oCAAA;AAuqBA;;AAvqBA;EAAA,kCAAA;AAuqBA;;AAvqBA;EAAA,+BAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,kBAAA;AAuqBA;;AAvqBA;EAAA,qBAAA;AAuqBA;;AAvqBA;EAAA,sBAAA;AAuqBA;;AAvqBA;EAAA,mBAAA;AAuqBA;;AAvqBA;EAAA,gBAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,mBAAA;AAuqBA;;AAvqBA;EAAA,0BAuqBA;EAvqBA,+LAAA;AAuqBA;;AAvqBA;;EAAA;IAAA,iBAAA;EAuqBA;;EAvqBA;IAAA,iBAAA;EAuqBA;;EAvqBA;IAAA,iBAAA;EAuqBA;AAAA","sourcesContent":["/* Animate css */\n@import './assets/css/animate.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer components {\n    html {\n        @apply scroll-smooth;\n    }\n\n    body {\n        @apply bg-[#fafafa] font-nunito;\n    }\n\n    body.dark {\n        @apply bg-[#060818];\n    }\n\n    /* Panel */\n    .panel {\n        @apply relative rounded-md bg-white p-5 shadow dark:bg-black;\n    }\n    /* Navbar */\n    .navbar-sticky header,\n    .navbar-floating header {\n        @apply sticky top-0 z-20;\n    }\n    .navbar-floating header {\n        @apply bg-[#fafafa]/90 px-6 pt-4 dark:bg-[#060818]/90;\n    }\n    .navbar-floating header > div .horizontal-menu {\n        @apply rounded-b-md shadow;\n    }\n\n    /* Sidebar */\n    .sidebar:hover .nav-item > a {\n        @apply w-auto;\n    }\n\n    .sidebar .nav-item > button,\n    .sidebar .nav-item > a {\n        @apply mb-1 flex items-center justify-between overflow-hidden whitespace-nowrap rounded-md p-2.5 text-[#506690] hover:bg-[#000]/[0.08] hover:text-black dark:hover:bg-[#181f32] dark:hover:text-white-dark w-full;\n    }\n    .sidebar .nav-item > button.active,\n    .sidebar .nav-item > a.active {\n        @apply bg-[#000]/[0.08] text-black dark:bg-[#181f32] dark:text-white-dark;\n    }\n\n    .sidebar .nav-item > button.active > div > span,\n    .sidebar .nav-item > a.active > div > span {\n        @apply dark:!text-white-dark;\n    }\n\n    .sidebar ul.sub-menu li button,\n    .sidebar ul.sub-menu li a {\n        @apply flex items-center px-9 py-2.5 before:h-0.5 before:w-2 before:rounded before:bg-gray-300 hover:bg-gray-100\n      hover:text-primary hover:before:!bg-primary ltr:before:mr-2 rtl:before:ml-2 dark:before:bg-gray-500 dark:hover:bg-gray-900 dark:hover:text-primary;\n    }\n    .sidebar ul.sub-menu li button.active,\n    .sidebar ul.sub-menu li a.active {\n        @apply text-primary before:bg-primary;\n    }\n\n    .sidebar .nav-item a div:first-child svg,\n    .sidebar .nav-item button div:first-child svg {\n        @apply w-5 h-5 text-black/50 dark:text-white/50;\n    }\n\n    .main-container .main-content {\n        @apply transition-all duration-300 lg:ltr:ml-[260px] lg:rtl:mr-[260px];\n    }\n\n    /* Horizontal layouts */\n    .horizontal .horizontal-menu {\n        @apply hidden shadow-md lg:flex;\n    }\n    .horizontal .horizontal-logo {\n        @apply flex;\n    }\n    .horizontal .main-container .main-content {\n        @apply ltr:ml-0 rtl:mr-0;\n    }\n    .horizontal .sidebar {\n        @apply ltr:-left-[260px] rtl:-right-[260px];\n    }\n    .horizontal.toggle-sidebar .sidebar {\n        @apply ltr:left-0 rtl:right-0 lg:ltr:-left-[260px] lg:rtl:-right-[260px];\n    }\n\n    .horizontal .nav-item a div:first-child svg,\n    .horizontal .nav-item button div:first-child svg {\n        @apply w-5 h-5 text-black/50 dark:text-white/50;\n    }\n\n    .horizontal .dark .nav-item button div:first-child svg,\n    .dark.horizontal .nav-item button div:first-child svg {\n        @apply text-white/50;\n    }\n\n    .horizontal-menu .nav-link {\n        @apply flex items-center py-2.5 px-2 rounded-lg hover:bg-[#000]/[0.08] hover:text-black dark:hover:bg-[#181f32] dark:hover:text-white-dark xl:px-4;\n    }\n\n    .horizontal-menu .nav-link.active {\n        @apply bg-[#000]/[0.08] text-black dark:bg-[#181f32] dark:text-white-dark;\n    }\n\n    .horizontal-menu ul.sub-menu {\n        @apply absolute top-full z-[10] hidden min-w-[180px] rounded bg-white p-0 py-2 text-dark shadow dark:bg-[#1b2e4b] dark:text-white-dark;\n    }\n\n    .horizontal-menu ul.sub-menu a,\n    .horizontal-menu ul.sub-menu button {\n        @apply flex items-center justify-between px-4 py-2 hover:bg-gray-100 hover:text-primary dark:hover:bg-primary/10 w-full;\n    }\n\n    .horizontal-menu ul.sub-menu a.active,\n    .horizontal-menu ul.sub-menu button.active {\n        @apply bg-gray-100 text-primary dark:bg-primary/10;\n    }\n\n    .horizontal-menu > li.nav-item:hover > ul.sub-menu,\n    .horizontal-menu > li.nav-item > ul.sub-menu > li:hover > ul {\n        @apply block;\n    }\n\n    /* Vertical layouts */\n    .vertical.toggle-sidebar .horizontal-logo,\n    .vertical.toggle-sidebar .collapse-icon {\n        @apply flex;\n    }\n    .vertical.toggle-sidebar .main-container .main-content {\n        @apply ltr:ml-0 rtl:mr-0;\n    }\n    .vertical .sidebar {\n        @apply ltr:-left-[260px] rtl:-right-[260px] lg:ltr:left-0 lg:rtl:right-0;\n    }\n    .vertical.toggle-sidebar .sidebar {\n        @apply ltr:left-0 rtl:right-0 lg:ltr:-left-[260px] lg:rtl:-right-[260px];\n    }\n\n    /* Collapsible vertical layouts */\n    .collapsible-vertical .sidebar {\n        @apply hover:w-[260px] ltr:-left-[260px] rtl:-right-[260px] lg:w-[70px] lg:ltr:left-0 lg:rtl:right-0;\n    }\n    .collapsible-vertical.toggle-sidebar .sidebar {\n        @apply ltr:left-0 rtl:right-0;\n    }\n    .collapsible-vertical.toggle-sidebar .sidebar {\n        @apply lg:w-[260px];\n    }\n    .collapsible-vertical.toggle-sidebar .sidebar .nav-item > a {\n        @apply w-auto;\n    }\n    .collapsible-vertical.toggle-sidebar .main-content {\n        @apply lg:w-[calc(100%-260px)] lg:ltr:ml-[260px] lg:rtl:mr-[260px];\n    }\n\n    .collapsible-vertical .sidebar .sub-menu {\n        @apply lg:hidden;\n    }\n    .collapsible-vertical .sidebar:hover .sub-menu,\n    .collapsible-vertical .sidebar:hover .sub-menu.recent-submenu,\n    .collapsible-vertical.toggle-sidebar .sidebar .sub-menu {\n        @apply block;\n    }\n    .collapsible-vertical .main-content {\n        @apply lg:w-[calc(100%-70px)] lg:ltr:ml-[70px] lg:rtl:mr-[70px];\n    }\n    .collapsible-vertical .sidebar .collapse-icon,\n    .collapsible-vertical .main-logo > span {\n        @apply transition-opacity duration-300 lg:opacity-0;\n    }\n    .collapsible-vertical .sidebar:hover .collapse-icon,\n    .collapsible-vertical.toggle-sidebar .collapse-icon,\n    .collapsible-vertical .sidebar:hover .main-logo > span,\n    .collapsible-vertical.toggle-sidebar .main-logo > span {\n        @apply duration-500 lg:opacity-100;\n    }\n    .collapsible-vertical.toggle-sidebar .sidebar .collapse-icon {\n        @apply flex rotate-0;\n    }\n    .collapsible-vertical .sidebar:hover .collapse-icon {\n        @apply flex rotate-180;\n    }\n    .collapsible-vertical .sidebar ul > h2 span {\n        @apply hidden whitespace-nowrap;\n    }\n    .collapsible-vertical .sidebar ul > h2 svg {\n        @apply block;\n    }\n    .collapsible-vertical .sidebar:hover ul > h2 span,\n    .collapsible-vertical.toggle-sidebar .sidebar ul > h2 span {\n        @apply inline;\n    }\n    .collapsible-vertical .sidebar:hover ul > h2 svg,\n    .collapsible-vertical.toggle-sidebar .sidebar ul > h2 svg {\n        @apply hidden;\n    }\n\n    /* boxed-layout */\n    .boxed-layout {\n        @apply mx-auto max-w-[1400px];\n    }\n\n    .boxed-layout.vertical .sidebar,\n    .boxed-layout.collapsible-vertical .sidebar {\n        @apply overflow-hidden lg:ltr:left-auto lg:rtl:right-auto;\n    }\n\n    .boxed-layout.vertical.toggle-sidebar .sidebar {\n        @apply lg:w-0;\n    }\n\n    /* Buttons */\n    .btn {\n        @apply relative flex items-center justify-center rounded-md border px-5 py-2 text-sm font-semibold shadow-[0_10px_20px_-10px] outline-none transition duration-300 hover:shadow-none;\n    }\n    .btn-lg {\n        @apply px-7 py-2.5 text-base;\n    }\n    .btn-sm {\n        @apply px-2.5 py-1.5 text-xs;\n    }\n    .btn[disabled] {\n        @apply cursor-not-allowed opacity-60;\n    }\n\n    .btn-primary {\n        @apply border-primary bg-primary text-white shadow-primary/60;\n    }\n    .btn-outline-primary {\n        @apply border-primary text-primary shadow-none hover:bg-primary hover:text-white;\n    }\n\n    .btn-secondary {\n        @apply border-secondary bg-secondary text-white shadow-secondary/60;\n    }\n    .btn-outline-secondary {\n        @apply border-secondary text-secondary shadow-none hover:bg-secondary hover:text-white;\n    }\n\n    .btn-success {\n        @apply border-success bg-success text-white shadow-success/60;\n    }\n    .btn-outline-success {\n        @apply border-success text-success shadow-none hover:bg-success hover:text-white;\n    }\n\n    .btn-danger {\n        @apply border-danger bg-danger text-white shadow-danger/60;\n    }\n    .btn-outline-danger {\n        @apply border-danger text-danger shadow-none hover:bg-danger hover:text-white;\n    }\n\n    .btn-warning {\n        @apply border-warning bg-warning text-white shadow-warning/60;\n    }\n    .btn-outline-warning {\n        @apply border-warning text-warning shadow-none hover:bg-warning hover:text-white;\n    }\n\n    .btn-info {\n        @apply border-info bg-info text-white shadow-info/60;\n    }\n    .btn-outline-info {\n        @apply border-info text-info shadow-none hover:bg-info hover:text-white;\n    }\n\n    .btn-dark {\n        @apply border-dark bg-dark text-white shadow-dark/60;\n    }\n\n    .btn-outline-dark {\n        @apply border-dark text-dark shadow-none hover:bg-dark hover:text-white;\n    }\n\n    /* Badge */\n    .badge {\n        @apply relative my-1 rounded border border-transparent px-2 py-0.5 text-xs font-semibold text-white;\n    }\n    .badge-outline-primary {\n        @apply border-primary text-primary hover:bg-primary-light dark:hover:bg-primary dark:hover:text-white-light;\n    }\n    .badge-outline-secondary {\n        @apply border-secondary text-secondary hover:bg-secondary-light dark:hover:bg-secondary dark:hover:text-white-light;\n    }\n    .badge-outline-success {\n        @apply border-success text-success hover:bg-success-light dark:hover:bg-success dark:hover:text-white-light;\n    }\n    .badge-outline-danger {\n        @apply border-danger text-danger hover:bg-danger-light dark:hover:bg-danger dark:hover:text-white-light;\n    }\n    .badge-outline-warning {\n        @apply border-warning text-warning hover:bg-warning-light dark:hover:bg-warning dark:hover:text-white-light;\n    }\n    .badge-outline-info {\n        @apply border-info text-info hover:bg-info-light dark:hover:bg-info dark:hover:text-white-light;\n    }\n    .badge-outline-dark {\n        @apply border-dark text-dark hover:bg-dark-light dark:hover:bg-dark dark:hover:text-white-light;\n    }\n\n    /* Form */\n    .form-input,\n    .form-textarea,\n    .form-select,\n    .form-multiselect {\n        @apply w-full rounded-md border border-white-light bg-white px-4 py-2 text-sm font-semibold text-black !outline-none focus:border-primary focus:ring-transparent dark:border-[#17263c] dark:bg-[#121e32] dark:text-white-dark dark:focus:border-primary;\n    }\n\n    .form-input-lg,\n    .form-textarea-lg,\n    .form-select-lg,\n    .form-multiselect-lg {\n        @apply py-2.5 text-base;\n    }\n    .form-input-sm,\n    .form-textarea-sm,\n    .form-select-sm,\n    .form-multiselect-sm {\n        @apply py-1.5 text-xs;\n    }\n    label {\n        @apply mb-1.5 block font-semibold;\n    }\n    [dir='rtl'] select {\n        background-position: left 0.5rem center;\n    }\n\n    .has-error .form-input,\n    .has-error .form-textarea,\n    .has-error .form-select,\n    .has-error .form-multiselect,\n    .has-error .multiselect__tags {\n        @apply border-danger text-danger bg-danger/[0.08] placeholder-danger/70 focus:border-danger;\n    }\n    .has-error .form-label,\n    .has-error .form-help,\n    .has-error .form-icon,\n    .has-error .multiselect__placeholder {\n        @apply text-danger;\n    }\n    .has-error .multiselect__input {\n        @apply bg-[#F7ECF0] !placeholder-danger/70;\n    }\n    .has-error .multiselect__tags:hover,\n    .has-error .form-checkbox {\n        @apply border-danger;\n    }\n\n    .has-success .form-input,\n    .has-success .form-textarea,\n    .has-success .form-select,\n    .has-success .form-multiselect,\n    .has-success .multiselect__tags {\n        @apply border-success text-success bg-success/[0.08] placeholder-success/70 focus:border-success;\n    }\n    .has-success .form-label,\n    .has-success .form-help,\n    .has-success .form-icon,\n    .has-success .multiselect__placeholder {\n        @apply text-success;\n    }\n    .has-success .multiselect__input {\n        @apply bg-[#F7ECF0] !placeholder-success/70;\n    }\n    .has-success .multiselect__tags:hover {\n        @apply border-success;\n    }\n\n    /* checkbox & radio */\n    .form-radio,\n    .form-checkbox {\n        @apply h-5 w-5 cursor-pointer rounded border-2 border-white-light bg-transparent text-primary !shadow-none !outline-none !ring-0 !ring-offset-0 checked:bg-[length:90%_90%] disabled:cursor-not-allowed disabled:bg-[#eee] ltr:mr-1.5 rtl:ml-1.5\n      dark:border-[#253b5c] dark:checked:border-transparent dark:disabled:bg-[#1b2e4b];\n    }\n\n    .form-checkbox.outline-primary:checked {\n        @apply border-primary bg-transparent;\n        background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%234361ee' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n    }\n    .form-checkbox.outline-secondary:checked {\n        @apply border-secondary bg-transparent;\n        background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23805dca' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n    }\n    .form-checkbox.outline-success:checked {\n        @apply border-success bg-transparent;\n        background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%2300ab55' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n    }\n    .form-checkbox.outline-danger:checked {\n        @apply border-danger bg-transparent;\n        background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23e7515a' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n    }\n    .form-checkbox.outline-warning:checked {\n        @apply border-warning bg-transparent;\n        background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%23e2a03f' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n    }\n    .form-checkbox.outline-info:checked {\n        @apply border-info bg-transparent;\n        background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%232196f3' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n    }\n    .form-checkbox.outline-dark:checked {\n        @apply border-dark bg-transparent;\n        background-image: url(\"data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%233b3f5c' xmlns='http://www.w3.org/2000/svg'><path d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/></svg>\");\n    }\n\n    .form-radio {\n        @apply rounded-full;\n    }\n\n    .form-radio.outline-primary:checked {\n        @apply border-primary bg-transparent bg-none;\n    }\n    .form-radio.outline-secondary:checked {\n        @apply border-secondary bg-transparent bg-none;\n    }\n    .form-radio.outline-success:checked {\n        @apply border-success bg-transparent bg-none;\n    }\n    .form-radio.outline-danger:checked {\n        @apply border-danger bg-transparent bg-none;\n    }\n    .form-radio.outline-warning:checked {\n        @apply border-warning bg-transparent bg-none;\n    }\n    .form-radio.outline-info:checked {\n        @apply border-info bg-transparent bg-none;\n    }\n    .form-radio.outline-dark:checked {\n        @apply border-dark bg-transparent bg-none;\n    }\n\n    /* dropdown */\n    .dropdown {\n        @apply relative;\n    }\n    .dropdown > button {\n        @apply flex;\n    }\n    .dropdown ul {\n        @apply my-1 min-w-[120px] rounded bg-white p-0 py-2 shadow dark:bg-[#1b2e4b] text-black dark:text-white-dark;\n    }\n    .dropdown ul li > a,\n    .dropdown ul li > button {\n        @apply flex items-center px-4 py-2 hover:bg-primary/10 hover:text-primary;\n    }\n    .dropdown ul li > button {\n        @apply w-full;\n    }\n\n    /* tables */\n    .table-responsive {\n        @apply overflow-auto;\n    }\n    table {\n        @apply w-full !border-collapse;\n    }\n    table thead tr,\n    table tfoot tr {\n        @apply border-b-0 bg-white-light/30  dark:!bg-[#1a2941];\n    }\n    table thead tr th,\n    table tfoot tr th,\n    table tbody tr td {\n        @apply py-3 px-4 ltr:text-left rtl:text-right;\n    }\n    table thead tr th,\n    table tfoot tr th {\n        @apply font-semibold;\n    }\n    table tbody tr {\n        @apply border-b !border-white-light/40 dark:!border-[#191e3a];\n    }\n    table.table-hover tbody tr {\n        @apply hover:!bg-white-light/20 dark:hover:!bg-[#1a2941]/40;\n    }\n    table.table-striped tbody tr:nth-child(odd) {\n        @apply !bg-white-light/20 dark:!bg-[#1a2941]/40;\n    }\n\n    table.dataTable-table tbody tr th,\n    table.dataTable-table tbody tr td {\n        @apply border-b border-[#e5e7eb] py-3 px-4 ltr:text-left rtl:text-right dark:border-[#191e3a];\n    }\n    table.dataTable-table tbody tr:last-child td {\n        @apply border-b-0;\n    }\n\n    /* code hightlight */\n    pre {\n        direction: ltr;\n    }\n}\n\n/* perfect scrollbar */\n.ps__rail-y > .ps__thumb-y,\n.ps__rail-y > .ps__thumb-y {\n    @apply !w-1.5 !bg-[#DDDDDD] dark:!bg-[#2d334c];\n}\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n    @apply !opacity-60;\n}\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n    @apply !bg-transparent;\n}\n\n/* swal2 */\n.swal2-container .swal2-close {\n    @apply text-white hover:text-dark-light focus:shadow-none;\n}\n\n.swal2-container .swal2-popup.swal2-toast {\n    @apply bg-dark py-2.5 px-5;\n}\n\n.swal2-popup.swal2-toast .swal2-title,\n.swal2-container .swal2-popup.swal2-toast .swal2-html-container {\n    @apply text-white;\n}\n.swal2-container .swal2-popup.swal2-toast.color-primary {\n    @apply bg-primary;\n}\n\n.swal2-container .swal2-popup.swal2-toast.color-secondary {\n    @apply bg-secondary;\n}\n\n.swal2-container .swal2-popup.swal2-toast.color-warning {\n    @apply bg-warning;\n}\n.swal2-container .swal2-popup.swal2-toast.color-info {\n    @apply bg-info;\n}\n.swal2-container .swal2-popup.swal2-toast.color-danger {\n    @apply bg-danger;\n}\n.swal2-container .swal2-popup.swal2-toast.color-success {\n    @apply bg-success;\n}\n\n/* apex chart */\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light,\n.apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light {\n    box-shadow: none;\n    @apply border-[#050717cc] bg-[#050717cc] text-white;\n}\n\n.apexcharts-canvas .apexcharts-xaxistooltip-bottom:before,\n.apexcharts-canvas .apexcharts-xaxistooltip-bottom:after {\n    @apply border-b-[#050717cc];\n}\n\n.apexcharts-canvas .apexcharts-tooltip-series-group.apexcharts-active {\n    @apply text-white;\n}\n\n.apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n    @apply border-dark bg-[#060818];\n}\n\n.apexcharts-legend-series {\n    @apply ltr:!mr-2 rtl:!ml-2;\n}\n\n.dark .apexcharts-title-text {\n    fill: #e0e6ed;\n}\n\n.dark .apexcharts-canvas .apexcharts-text.apexcharts-xaxis-label,\n.dark .apexcharts-canvas .apexcharts-text.apexcharts-yaxis-label {\n    fill: #e0e6ed;\n}\n\n.dark .apexcharts-canvas .apexcharts-text,\n.dark .apexcharts-canvas .apexcharts-text {\n    fill: #e0e6ed;\n}\n\n.dark .apexcharts-canvas .apexcharts-legend-text {\n    color: #e0e6ed !important;\n}\n\n.dark .apexcharts-canvas .apexcharts-radialbar-track.apexcharts-track .apexcharts-radialbar-area {\n    stroke: #191e3a;\n}\n.dark .apexcharts-canvas .apexcharts-series-markers.apexcharts-series-bubble .apexcharts-marker {\n    stroke: #191e3a;\n}\n\n.dark .apexcharts-canvas .apexcharts-pie-label,\n.dark .apexcharts-canvas .apexcharts-datalabel,\n.dark .apexcharts-canvas .apexcharts-datalabel-label,\n.dark .apexcharts-canvas .apexcharts-datalabel-value {\n    fill: #bfc9d4;\n}\n\n.dark .apexcharts-canvas .apexcharts-tooltip.apexcharts-theme-dark {\n    box-shadow: none;\n}\n\n.apexcharts-canvas .apexcharts-legend-marker {\n    @apply ltr:!mr-1.5 rtl:ml-1.5 rtl:!mr-0;\n}\n\n[dir='rtl'] .apexcharts-tooltip-marker {\n    @apply mr-0 ml-2.5;\n}\n\n/* Animations */\n.slide-down-enter-active {\n    @apply transition duration-100 ease-out;\n}\n.slide-down-leave-active {\n    @apply transition duration-75 ease-in;\n}\n.slide-down-enter-from,\n.slide-down-leave-to {\n    @apply transform scale-95 opacity-0;\n}\n.slide-down-enter-to,\n.slide-down-leave-from {\n    @apply transform scale-100 opacity-100;\n}\n\n.modal-fade-enter-active {\n    @apply transition duration-300 ease-out;\n}\n.modal-fade-leave-active {\n    @apply transition duration-200 ease-in;\n}\n.modal-fade-enter-from,\n.modal-fade-leave-to {\n    @apply transform opacity-0 scale-95;\n}\n.modal-fade-enter-to,\n.modal-fade-leave-from {\n    @apply transform opacity-100 scale-100;\n}\n\n/* Hightlight JS */\npre.hljs {\n    @apply p-6 rounded-md overflow-x-auto !bg-[#191e3a];\n}\n\n/* Styling tambahan untuk DataTable */\n.dataTable-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.dataTable-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background: #f8f9fa;\n  border-top: 1px solid #ddd;\n}\n\n.dataTable-pagination {\n  display: flex;\n  justify-content: flex-end;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
